export const locationData = [
  {
  // We use a special key for non-state options
  "__GENERAL__": ["India", "Special Day Wishes"], 
  
  "state_en": "Andhra Pradesh",
  "state_te": "ఆంధ్రప్రదేశ్",
  "districts": [
    {
      "district_en": "Alluri Sitharama Raju",
      "district_te": "శ్రీ అల్లూరి సీతారామ రాజు",
      "constituencies": [
        { value: "Arakuvalley", label: "అరకులోయ" },{ value: "Paderu", label: "పాడేరు" },{ value: "Rampachodavaram", label: "రంపచోడవరం" }
      ],
      "mandals": [
        { value: "Ananthagiri", label: "అనంతగిరి" },{ value: "Arakuvalley", label: "అరకులోయ" },
    { value: "Chintapalli", label: "చింతపల్లి" },{ value: "Koyyuru", label: "కొయ్యూరు" },{ value: "Dumbriguda", label: "డుంబ్రిగుడ" },
    { value: "Gangaraju Madugula", label: "గంగరాజు మాడుగుల" },{ value: "Gudem Kothaveedhi", label: "గూడెం కొత్తవీధి" },{ value: "Hukumpeta", label: "హుకుంపేట" },
    { value: "Kunavaram", label: "కూనవరం" },{ value: "Munchangiputtu", label: "ముంచంగిపుట్టు" },{ value: "Paderu", label: "పాడేరు" },
    { value: "Pedabayalu", label: "పెదబయలు" },{ value: "Y.Ramavaram", label: "వై.రామవరం" },{ value: "Addateegala", label: "అడ్డతీగల" },
    { value: "Devipatnam", label: "దేవీపట్నం" },{ value: "Ganapavaram", label: "గణపవరం" },{ value: "Maredumilli", label: "మారేడుమిల్లి" },
    { value: "Rajavommangi", label: "రాజవొమ్మంగి" },{ value: "Rampachodavaram", label: "రంపచోడవరం" },{ value: "K.Gangavaram", label: "కె. గంగవరం" },
    { value: "Chinturu", label: "చింతూరు" },{ value: "V.R.Puram", label: "వరరామచంద్రపురం" },{ value: "Etapaka", label: "ఎటపాక" }
      ]
    },

    {
  "district_en": "Anakapalli",
  "district_te": "అనకాపల్లి",
  "constituencies": [
    { value: "Anakapalli", label: "అనకాపల్లి" },
    { value: "Chodavaram", label: "చోడవరం" },
    { value: "Yelamanchili", label: "యలమంచిలి" },
    { value: "Madugula", label: "మాడుగుల" },
    { value: "Narsipatnam", label: "నర్సీపట్నం" },
    { value: "Payakaraopeta", label: "పాయకరావుపేట" },
    { value: "Pendurthi", label: "పెందుర్తి" }
  ],
  "mandals": [
    { value: "Anakapalli", label: "అనకాపల్లి" },
    { value: "Achyutapuram", label: "అచ్యుతాపురం" },
    { value: "Buchchayyapeta", label: "బుచ్చయ్యపేట" },
    { value: "Chodavaram", label: "చోడవరం" },
    { value: "Devarapalli", label: "దేవరాపల్లి" },
    { value: "Yelamanchili", label: "యలమంచిలి" },
    { value: "Kasimkota", label: "కశింకోట" },
    { value: "K.Kotapadu", label: "కె.కోటపాడు" },
    { value: "Madugula", label: "మాడుగుల" },
    { value: "Munagapaka", label: "మునగపాక" },
    { value: "Makavarapalem", label: "మాకవరపాలెం" },
    { value: "Nakkapalli", label: "నక్కపల్లి" },
    { value: "Narsipatnam", label: "నర్సీపట్నం" },
    { value: "Nathavaram", label: "నాతవరం" },
    { value: "Payakaraopeta", label: "పాయకరావుపేట" },
    { value: "Pendurthi", label: "పెందుర్తి" },
    { value: "Rambilli", label: "రాంబిల్లి" },
    { value: "Ravikamatham", label: "రావికమత" },
    { value: "Rolugunta", label: "రోలుగుంట" },
    { value: "S.Rayavaram", label: "ఎస్.రాయవరం" },
    { value: "Sabbavaram", label: "సబ్బవరం" },
    { value: "Chidikada", label: "చీడికాడ" },
    { value: "Paravada", label: "పరవాడ" },
    { value: "Pedagantyada", label: "పెదగంట్యాడ" },
    { value: "Kotauratla", label: "కోటవురట్ల" },
    { value: "Golugonda", label: "గొలుగొండ" }
  ]
},
    {
  "district_en": "Anantapur",
  "district_te": "అనంతపురము",
  "constituencies": [
    { value: "Anantapur Urban", label: "అనంతపురం అర్బన్" },
    { value: "Kalyanadurgam", label: "కళ్యాణదుర్గం" },
    { value: "Raptadu", label: "రాప్తాడు" },
    { value: "Rayadurgam", label: "రాయదుర్గం" },
    { value: "Singanamala", label: "శింగనమల" },
    { value: "Tadipatri", label: "తాడిపత్రి" },
    { value: "Uravakonda", label: "ఉరవకొండ" },
    { value: "Guntakal", label: "గుంతకల్" }
  ],
  "mandals": [
    { value: "Anantapuram", label: "అనంతపురం" },
    { value: "Atmakur", label: "ఆత్మకూరు" },
    { value: "Anantapur Urban", label: "అనంతపురం అర్బన్" },
    { value: "Beluguppa", label: "బెళుగుప్ప" },
    { value: "Chennekothapalli", label: "చెన్నేకొత్తపల్లి" },
    { value: "Bommanahal", label: "బొమ్మనహళ్ళి" },
    { value: "Ellanur", label: "ఎల్లనూరు" },
    { value: "Brahmasamudram", label: "బ్రహ్మసముద్రం" },
    { value: "Bukkarayasamudram", label: "బుక్కరాయసముద్రం" },
    { value: "Garladinne", label: "గార్లదిన్నె" },
    { value: "Kuderu", label: "కూడేరు" },
    { value: "Kanekal", label: "కనేకల్" },
    { value: "Kalyanadurgam", label: "కళ్యాణదుర్గం" },
    { value: "Kambadur", label: "కంబదూరు" },
    { value: "Kakkalapalle_R", label: " కక్కలపల్లె (ఆర్)" },
    { value: "Kundurpi", label: "కుందుర్పి" },
    { value: "Narpala", label: "నార్పల" },
    { value: "Narayanapuram", label: "నారాయణపురం" },
    { value: "Peddapappur", label: "పెద్దపప్పూరు" },
    { value: "Peddavadugur", label: "పెద్దవడుగూరు" },
    { value: "Singanamala", label: "సింగనమల" },
    { value: "Settur", label: "సెట్టూరు" },
    { value: "Guntakal", label: "గుంతకల్" },
    { value: "Gooty", label: "గుత్తి" },
    { value: "Putlur", label: "పుట్లూరు" },
    { value: "Raptadu", label: "రాప్తాడు" },
    { value: "Ramgiri", label: "రామగిరి" },
    { value: "Rayadurgam", label: "రాయదుర్గం" },
    { value: "Singanamala_2", label: "శింగనమల" },
    { value: "D.Hirehal", label: "డి.హిరేహాల్" },
    { value: "Gummagatta", label: "గుమ్మఘట్ట" },
    { value: "Tadipatri", label: "తాడిపత్రి" },
    { value: "Uravakonda", label: "ఉరవకొండ" },
    { value: "Pamidi", label: "పామిడి" },
    { value: "Vajrakarur", label: "వజ్రకరూరు" },
    { value: "Vidapanakal", label: "విడపనకల్లు" },
    { value: "Yadiki", label: "యాడికి" },
    { value: "Kanaganapalli", label: "కనగానపల్లి" },
    { value: "Ellanur", label: "ఎల్లనూరు" }
  ]
},
    {
  "district_en": "Annamayya",
  "district_te": "అన్నమయ్య",
  "constituencies": [
    { value: "Madanapalle", label: "మదనపల్లె" },
  { value: "Pileru", label: "పీలేరు" },
  { value: "Punganur", label: "పుంగనూరు" },
  { value: "Rayachoti", label: "రాయచోటి" },
  { value: "Rajampet", label: "రాజంపేట" },
  { value: "Tamballapalle", label: "తంబళ్లపల్లె" },
  { value: "Kodur", label: "కోడూరు" }
  ],
  "mandals": [
    { value: "Kodur", label: "కోడూరు" },
  { value: "Chinnamandem", label: "చిన్నమండెం" },
  { value: "Obulavaripalle", label: "ఓబులవారిపల్లె" },
  { value: "Galiveedu", label: "గాలివీడు" },
  { value: "Kalasapadu", label: "కలసపాడు" },
  { value: "Chitvel", label: "చిట్వేలు" },
  { value: "Lakkireddipalle", label: "లక్కిరెడ్డిపల్లె" },
  { value: "Madanapalle", label: "మదనపల్లె" },
  { value: "Nimmanapalle", label: "నిమ్మనపల్లె" },
  { value: "Pileru", label: "పీలేరు" },
  { value: "Pullampet", label: "పుల్లంపేట" },
  { value: "Penagalur", label: "పెనగలూరు" },
  { value: "Rayachoti", label: "రాయచోటి" },
  { value: "Ramasamudram", label: "రామసముద్రం" },
  { value: "Sambepalli", label: "సంబేపల్లి" },
  { value: "Tamballapalle", label: "తంబళ్లపల్లె" },
  { value: "Valmikipuram", label: "వాల్మీకిపురం" },
  { value: "Kurabalakota", label: "కురబలకోట" },
  { value: "Peddathippasamudram", label: "పెద్దతిప్పసముద్రం" },
  { value: "Peddamandyam", label: "పెద్దమండ్యం" },
  { value: "B.Kothakota", label: "బి.కొత్తకోట" },
  { value: "Mulakalacheruvu", label: "ములకలచెరువు" },
  { value: "Kalikada", label: "కలకడ" },
  { value: "Kalikiri", label: "కలికిరి" },
  { value: "Kambhamvaripalle", label: "కంభంవారిపల్లె" },
  { value: "Gurramkonda", label: "గుర్రంకొండ" },
  { value: "Ontimitta", label: "ఒంటిమిట్ట" },
  { value: "Siddavatam", label: "సిద్ధవటం" },
  { value: "Rajampet", label: "రాజంపేట" },
  { value: "Veeraballe", label: "వీరబల్లె" },
  { value: "T.Sundupalle", label: "టి.సుండుపల్లి" }
  ]
  
  
},
    {
  "district_en": "Bapatla",
  "district_te": "బాపట్ల",
  "constituencies": [
    { value: "Bapatla", label: "బాపట్ల" },
  { value: "Chirala", label: "చీరాల" },
  { value: "Parchur", label: "పర్చూరు" },
  { value: "Repalle", label: "రేపల్లె" },
  { value: "Addanki", label: "అద్దంకి" },
  { value: "Vemuru", label: "వేమూరు" }
  ],
  "mandals": [
    { value: "Addanki", label: "అద్దంకి" },
  { value: "Amruthaluru", label: "అమృతలూరు" },
  { value: "Bapatla", label: "బాపట్ల" },
  { value: "Ballikurava", label: "బల్లికురవ" },
  { value: "Bhattiprolu", label: "భట్టిప్రోలు" },
  { value: "Sundur", label: "సుండూరు" },
  { value: "Chirala", label: "చీరాల" },
  { value: "Chilakaluripet", label: "చిలకలూరిపేట" },
  { value: "Cherukupalle", label: "చెరుకుపల్లి" },
  { value: "Chunduru", label: "చుండూరు" },
  { value: "Yadlapadu", label: "యడ్లపాడు" },
  { value: "GramaPanchayati", label: "గ్రామపంచాయతీ" },
  { value: "Inkollu", label: "ఇంకొల్లు" },
  { value: "J.Panguluru", label: "జె.పంగులూరు" },
  { value: "Karanchedu", label: "కారంచేడు" },
  { value: "Kolluru", label: "కొల్లూరు" },
  { value: "Korishapadu", label: "కొరిశపాడు" },
  { value: "Karlapalem", label: "కర్లపాలెం" },
  { value: "Chinaganjam", label: "చినగంజాం" },
  { value: "Martur", label: "మార్టూరు" },
  { value: "Nadendla", label: "నాదెండ్ల" },
  { value: "Nagaram", label: "నగరం" },
  { value: "Nizampatnam", label: "నిజాంపట్నం" },
  { value: "Parchur", label: "పర్చూరు" },
  { value: "Pittalavanipalem", label: "పిట్టలవానిపాలెం" },
  { value: "Repalle", label: "రేపల్లె" },
  { value: "Santamaguluru", label: "సంతమాగులూరు" },
  { value: "Vemuru", label: "వేమూరు" },
  { value: "Vetapalem", label: "వేటపాలెం" }
  ]
},
    {
  "district_en": "Chittoor",
  "district_te": "చిత్తూరు",
  "constituencies": [
    { value: "Chittoor", label: "చిత్తూరు" },
  { value: "Gangadhara Nellore", label: "గంగాధర నెల్లూరు" },
  { value: "Kuppam", label: "కుప్పం" },
  { value: "Nagari", label: "నగరి" },
  { value: "Palamaner", label: "పలమనేరు" },
  { value: "Puthalapattu", label: "పూతలపట్టు" },
  { value: "Punganur", label: "పుంగనూరు" }
  ],
  "mandals": [
    { value: "Kuppam", label: "కుప్పం" },
  { value: "Gudipalle", label: "గుడిపల్లె" },
  { value: "Ramakuppam", label: "రామకుప్పం" },
  { value: "Santipuram", label: "శాంతిపురం" },
  { value: "Karvetinagar", label: "కార్వేటినగరం" },
  { value: "Gangadhara Nellore", label: "గంగాధర నెల్లూరు" },
  { value: "Palasamudram", label: "పాలసముద్రం" },
  { value: "Penumur", label: "పెనుమూరు" },
  { value: "Vedurukuppam", label: "వెదురుకుప్పం" },
  { value: "Srirangarajapuram", label: "శ్రీరంగరాజపురం" },
  { value: "Chittoor", label: "చిత్తూరు" },
  { value: "Nagari", label: "నగరి" },
  { value: "Nindra", label: "నిండ్ర" },
  { value: "Puttur", label: "పుత్తూరు" },
  { value: "Vadamala Peta", label: "వడమాలపేట" },
  { value: "Palamaner", label: "పలమనేరు" },
  { value: "Gangavaram", label: "గంగవరం" },
  { value: "Irala", label: "ఐరాల" },
  { value: "Vijayapuram", label: "విజయపురం" },
  { value: "Baireddipalle", label: "బైరెడ్డిపల్లె" },
  { value: "Peddapanjani", label: "పెద్దపంజాణి" },
  { value: "Venkatagirikota", label: "వెంకటగిరి కోట" },
  { value: "Chowdepalle", label: "చౌడేపల్లె" },
  { value: "Pulicherla", label: "పులిచెర్ల" },
  { value: "Punganur", label: "పుంగనూరు" },
  { value: "Rompepalle", label: "రొంపిచర్ల" },
  { value: "Sadum", label: "సదుం" },
  { value: "Somala", label: "సోమల" },
  { value: "Bangarupalem", label: "బంగారుపాళ్యం" },
  { value: "Thavanampalle", label: "తవణంపల్లి" },
  { value: "Puthalapattu", label: "పూతలపట్టు" },
  { value: "Yadamari", label: "యాదమరి" }
  ]
},

    {
  "district_en": "East Godavari",
  "district_te": "తూర్పు గోదావరి",
  "constituencies": [
    { value: "Anaparti", label: "అనపర్తి" },
  { value: "Rajah Nagarama", label: "రాజానగరం" },
  { value: "Rajamahendravaram City", label: "రాజమండ్రి సిటీ" },
  { value: "Rajamahendravaram Rural", label: "రాజమండ్రి రూరల్" },
  { value: "Gopalapuram", label: "గోపాలపురం" },
  { value: "Kovvur", label: "కొవ్వూరు" },
  { value: "Nidadavole", label: "నిడదవోలు" }

  ],
  "mandals": [
   { value: "Pedapudi (Kakinada District)", label: "పెదపూడి (కాకినాడ జిల్లా)" },
  { value: "Biccavolu (East Godavari District)", label: "బిక్కవోలు (తూర్పుగోదావరి జిల్లా)" },
  { value: "Rangampeta (East Godavari District)", label: "రంగంపేట (తూర్పుగోదావరి జిల్లా)" },
  { value: "Anaparti (East Godavari District)", label: "అనపర్తి (తూర్పుగోదావరి జిల్లా)" },
  { value: "Korukonda", label: "కోరుకొండ" },
  { value: "Nidadavole", label: "నిడదవోలు" },
  { value: "Rajah Nagarama", label: "రాజానగరం" },
  { value: "Seethanagaram", label: "సీతానగరం" },
  { value: "Rajamahendravaram Urban", label: "రాజమండ్రి పట్టణ" },
  { value: "Rajamahendravaram Municipal Corporation", label: "రాజమహేంద్రవరం నగరపాలక సంస్థ" },
  { value: "Kadiyam", label: "కడియం" },
  { value: "Rajamahendravaram Rural", label: "రాజమండ్రి గ్రామీణ" },
  { value: "Rajamahendravaram Urban 2", label: "రాజమహేంద్రవరం పట్టణ" },
  { value: "Dwaraka Tirumala (Eluru District)", label: "ద్వారకా తిరుమల (ఏలూరు జిల్లా)" },
  { value: "Nallajerla (East Godavari District)", label: "నల్లజర్ల (తూర్పు గోదావరి జిల్లా)" },
  { value: "Devarapalli (East Godavari District)", label: "దేవరపల్లి (తూర్పు గోదావరి జిల్లా)" },
  { value: "Gopalapuram (East Godavari District)", label: "గోపాలపురం (తూర్పుగోదావరి జిల్లా)" },
  { value: "Kovvur", label: "కొవ్వూరు" },
  { value: "Chagallu", label: "చాగల్లు" },
  { value: "Tallapudi", label: "తాళ్లపూడి" },
  { value: "Undrajavaram", label: "ఉండ్రాజవరం" },
  { value: "Peravali", label: "పెరవలి" }


  ]
},
    {
  "district_en": "Eluru",
  "district_te": "ఏలూరు",
  "constituencies": [
    { value: "Eluru", label: "ఏలూరు" },
  { value: "Denduluru", label: "దెందులూరు" },
  { value: "Chintalapudi", label: "చింతలపూడి" },
  { value: "Nuzvid", label: "నూజివీడు" },
  { value: "Kaikaluru", label: "కైకలూరు" },
  { value: "Polavaram", label: "పోలవరం" },
  { value: "Unguturu", label: "ఉంగుటూరు" }
  ],
  "mandals": [
    { value: "Eluru", label: "ఏలూరు" },
  { value: "Denduluru", label: "దెందులూరు" },
  { value: "Chintalapudi", label: "చింతలపూడి" },
  { value: "Nuzvid", label: "నూజివీడు" },
  { value: "Kaikaluru", label: "కైకలూరు" },
  { value: "Polavaram", label: "పోలవరం" },
  { value: "Unguturu", label: "ఉంగుటూరు" },
  { value: "Ganapavaram", label: "గణపవరం" },
  { value: "Kamavarapukota", label: "కామవరపుకోట" },
  { value: "Jangareddygudem", label: "జంగారెడ్డిగూడెం" },
  { value: "Lingapalem", label: "లింగపాలెం" },
  { value: "Nidamarru", label: "నిడమర్రు" },
  { value: "Bhimadole", label: "భీమడోలు" },
  { value: "Agiripalli", label: "ఆగిరిపల్లి" },
  { value: "Mandavalli", label: "మందవల్లి" },
  { value: "Kalidindi", label: "కలిదిండి" },
  { value: "Mudinepalli", label: "ముదినేపల్లి" },
  { value: "Chatrai", label: "చాట్రాయి" },
  { value: "Musunuru", label: "ముసునూరు" },
  { value: "Kukunuru", label: "కుక్కునూరు" },
  { value: "Koyyalagudem", label: "కొయ్యలగూడెం" },
  { value: "Jeelugumilli", label: "జీలుగుమిల్లి" },
  { value: "T.Narasapuram", label: "టి.నరసాపురం" },
  { value: "Buttayagudem", label: "బుట్టాయగూడెం" },
  { value: "Velerupadu", label: "వేలేరుపాడు" }
  ]
},

    {
  "district_en": "Guntur",
  "district_te": "గుంటూరు",
  "constituencies": [
    { value: "GunturEast", label: "గుంటూరు తూర్పు" },
  { value: "GunturWest", label: "గుంటూరు పశ్చిమ" },
  { value: "Prathipadu", label: "ప్రతిపాడు" },
  { value: "Tadikonda", label: "తాడికొండ" },
  { value: "Mangalagiri", label: "మంగళగిరి" },
  { value: "Ponnur", label: "పొన్నూరు" },
  { value: "Tenali", label: "తెనాలి" }
  ],
  "mandals": [
    { value: "GunturWest", label: "గుంటూరు (వెస్ట్)" },
  { value: "GunturEast", label: "గుంటూరు (ఈస్ట్)" },
  { value: "Thulluru", label: "తుల్లూరు" },
  { value: "Tadikonda", label: "తాడికొండ" },
  { value: "Pirangipuram", label: "పిరంగిపురం" },
  { value: "Medikonduru", label: "మేడికొండూరు" },
  { value: "Kollipara", label: "కొల్లిపారా" },
  { value: "Tenali", label: "తెనాలి" },
  { value: "Ponnur", label: "పొన్నూరు" },
  { value: "Chebrolu", label: "చెబ్రోలు" },
  { value: "Pedakakani", label: "పెదకాకాని" },
  { value: "Vatticherukuru", label: "వట్టి చెరుకొరు" },
  { value: "Prathipadu", label: "ప్రత్తిపాడు" },
  { value: "Pedanandipadu", label: "పెదనందిపాడు" },
  { value: "Kakumanu", label: "కాకుమాను" },
  { value: "Mangalagiri", label: "మంగళగిరి" },
  { value: "Tadepalli", label: "తాడేపల్లి" },
  { value: "Duggirala", label: "దుగ్గిరాల" }   
  ]
},

{
  "district_en": "Kadapa",
  "district_te": "కడప",
  "constituencies": [
    { value: "Kadapa City", label: "కడప నగరం" },
    { value: "Kadapa Rural", label: "కడప గ్రామీణం" },
    { value: "Kamalapuram", label: "కమలాపురం" },
    { value: "Jammalamadugu", label: "జమ్మలమడుగు" },
    { value: "Proddatur", label: "ప్రొద్దుటూరు" },
    { value: "Pulivendula", label: "పులివెందుల" },
    { value: "Badvel", label: "బద్వేల్" },
    { value: "Mydukur", label: "మైదుకూరు" }
  ],
  "mandals": [
    { value: "Kadapa City", label: "కడప నగరం" },
    { value: "Kadapa Rural", label: "కడప గ్రామీణం" },
    { value: "Kamalapuram", label: "కమలాపురం" },
    { value: "Jammalamadugu", label: "జమ్మలమడుగు" },
    { value: "Proddatur", label: "ప్రొద్దుటూరు" },
    { value: "Pulivendula", label: "పులివెందుల" },
    { value: "Badvel", label: "బద్వేల్" },
    { value: "Mydukur", label: "మైదుకూరు" },
    { value: "Chintakomma Dinne", label: "చింతకొమ్మదిన్నె" },
    { value: "Chennur", label: "చెన్నూరు" },
    { value: "Pendlimarri", label: "పెండ్లిమర్రి" },
    { value: "Veerapunayunipalle", label: "వీరపునాయునిపల్లె" },
    { value: "Vallur", label: "వల్లూరు" },
    { value: "Kondapuram", label: "కొండాపురం" },
    { value: "Peddamudium", label: "పెద్దముడియం" },
    { value: "Muddunur", label: "ముద్దనూరు" },
    { value: "Mylavaram", label: "మైలవరం" },
    { value: "Yerraguntla", label: "యర్రగుంట్ల" },
    { value: "Chakrayapeta", label: "చక్రాయపేట" },
    { value: "Tondur", label: "తొండూరు" },
    { value: "Lingala", label: "లింగాల" },
    { value: "Vemula", label: "వేముల" },
    { value: "Vempalle", label: "వేంపల్లె" },
    { value: "Simhadripuram", label: "సింహాద్రిపురం" },
    { value: "Rajupalem", label: "రాజుపాలెం" },
    { value: "Khajipet", label: "ఖాజీపేట" },
    { value: "Atlur", label: "అట్లూరు" },
    { value: "Kalasa Padu", label: "కలసపాడు" },
    { value: "Gopavaram", label: "గోపవరం" },
    { value: "Porumamilla", label: "పోరుమామిళ్ల" },
    { value: "Chapadu", label: "చాపాడు" },
    { value: "Badvel (Rural)", label: "బద్వేలు" },
    { value: "B Kodur", label: "బి.కోడూరు" },
    { value: "Sri Avadhuta Kashinayana", label: "శ్రీఅవధూత కాశినాయన" },
    { value: "Duvvur", label: "దువ్వూరు" },
    { value: "Brahmamgari Matham", label: "బ్రహ్మంగారిమఠం" }
]
},

    {
  "district_en": "Kakinada",
  "district_te": "కాకినాడ",
  "constituencies": [
    { value: "Kakinada City", label: "కాకినాడ నగరం" },
    { value: "Kakinada Rural", label: "కాకినాడ గ్రామీణం" },
    { value: "Tuni", label: "తుని" },
    { value: "Prathipadu", label: "ప్రత్తిపాడు" },
    { value: "Pithapuram", label: "పిఠాపురం" },
    { value: "Kakinada Rural l", label: "కాకినాడ రూరల్l" },
    { value: "Peddapuram", label: "పెద్దాపురం" },
    { value: "Jaggampeta", label: "జగ్గంపేట" }
  ],
  "mandals": [
    { value: "Kakinada City", label: "కాకినాడ నగరం" },
    { value: "Kakinada Rural", label: "కాకినాడ గ్రామీణం" },
    { value: "Tuni", label: "తుని" },
    { value: "Prathipadu", label: "ప్రత్తిపాడు" },
    { value: "Pithapuram", label: "పిఠాపురం" },
    { value: "Kakinada Rural l", label: "కాకినాడ రూరల్l" },
    { value: "Peddapuram", label: "పెద్దాపురం" },
    { value: "Jaggampeta", label: "జగ్గంపేట" },
    { value: "Tondangi", label: "తొండంగి" },
    { value: "Kothananduru", label: "కోటనందూరు" },
    { value: "Eleswaram", label: "ఏలేశ్వరం " },
    { value: "Shankhavaram", label: "శంఖవరం" },
    { value: "Routhulapudi", label: "రౌతులపూడి" },
    { value: "Gollaprolu", label: "గొల్లప్రోలు" },
    { value: "Karapa", label: "కరప" },
    { value: "Samarakota", label: "సామర్లకోట" },
    { value: "Kirlampudi", label: "కిర్లంపూడి" },
    { value: "Gandepalli", label: "గండేపల్లి" },
    { value: "U Kottapalli", label: "యు.కొత్తపల్లి" },
    { value: "Gokavaram (East Godavari District)", label: "గోకవరం(తూర్పు గోదావరి జిల్లా)" }
  ]      
},

    {
  "district_en": "Konaseema",
  "district_te": "కోనసీమ",
  "constituencies": [
    { value: "Amalapuram", label: "అమలాపురం" },
    { value: "Mummidivaram", label: "ముమ్మిడివరం" },
    { value: "Rajolu", label: "రాజోలు" },
    { value: "Ramachandrapuram", label: "రామచంద్రపురం" },
    { value: "P Gannavaram", label: "పి.గన్నవరం" },
    { value: "Kothapeta", label: "కొత్తపేట" },
    { value: "Mandapeta", label: "మండపేట" }
  ],
  "mandals": [
    { value: "Allavaram", label: "అల్లవరం" },
    { value: "Amalapuram", label: "అమలాపురం" },
    { value: "I Polavaram", label: "ఐ. పోలవరం" },
    { value: "Katrenikona", label: "కాత్రేనికోన" },
    { value: "Malikipuram", label: "మలికిపురం" },
    { value: "Mamidikuduru", label: "మామిడికుదురు" },
    { value: "Mummidivaram", label: "ముమ్మిడివరం" },
    { value: "Rajolu", label: "రాజోలు" },
    { value: "Sakinetipalli", label: "సఖినేటిపల్లి" },
    { value: "Uppalaguptam", label: "ఉప్పలగుప్తం" },
    { value: "Inavilli", label: "ఐనవిల్లి" },
    { value: "Ambajipeta", label: "అంబాజిపేట" },
    { value: "Atreyapuram", label: "ఆత్రేయపురం" },
    { value: "Kothapeta", label: "కొత్తపేట" },
    { value: "P Gannavaram", label: "పి. గన్నవరం" },
    { value: "Ravulapalem", label: "రావులపాలెం" },
    { value: "K Gangavaram", label: "కె. గంగవరం" },
    { value: "Kapileshwarapuram", label: "కపిలేశ్వర పూరం" },
    { value: "Mandapeta", label: "మండపేట" },
    { value: "Ramachandrapuram", label: "రామచంద్రపురం" },
    { value: "Kajuluru (Kakinada District)", label: "కాజులూరు(కాకినాడ జిల్లా)" },
    { value: "Rayavaram", label: "రాయవరం" }
  ]
},

    {
  "district_en": "Krishna",
  "district_te": "కృష్ణ",
  "constituencies": [
    { value: "Avanigadda", label: "అవనిగడ్డ" },
    { value: "Gannavaram", label: "గన్నవరం" },
    { value: "Gudivada", label: "గుడివాడ" },
    { value: "Pamarru", label: "పామర్రు" },
    { value: "Pedan", label: "పెడన" },
    { value: "Penamaluru", label: "పెనమలూరు" },
    { value: "Machilipatnam", label: "మచిలీపట్నం" }
  ],
  "mandals": [
    { value: "Koduru", label: "కోడూరు" },
    { value: "Ghantasala", label: "ఘంటసాల" },
    { value: "Challapalli", label: "చల్లపల్లి" },
    { value: "Nagayalanka", label: "నాగాయలంక" },
    { value: "Mopidevi", label: "మోపిదేవి" },
    { value: "Unguturu", label: "ఉంగుటూరు" },
    { value: "Gannavaram", label: "గన్నవరం" },
    { value: "Avanigadda", label: "అవనిగడ్డ" },
    { value: "Nandivada", label: "నందివాడ" },
    { value: "Bapulapadu", label: "బాపులపాడు" },
    { value: "Vijayawada Rural", label: "విజయవాడ గ్రామీణ " },
    { value: "Gudlavalleru", label: "గుడ్లవల్లేరు" },
    { value: "Thotlavalluru", label: "తోట్లవల్లూరు" },
    { value: "Pamidimukkala", label: "పమిడిముక్కల" },
    { value: "Pedaparupudi", label: "పెదపారుపూడి" },
    { value: "Movva", label: "మొవ్వ" },
    { value: "Kritivennu", label: "కృతివెన్ను" },
    { value: "Guduru", label: "గూడూరు" },
    { value: "Bantumilli", label: "బంటుమిల్లి" },
    { value: "Kankipadu", label: "కంకిపాడు" },
    { value: "Penamaluru", label: "పెనమలూరు" },
    { value: "Machilipatnam", label: "మచిలీపట్నం " }  
  ]
},

  {
  "district_en": "Kurnool",
  "district_te": "కర్నూలు",
  "constituencies": [
    { value: "Kurnool", label: "కర్నూలు" },
    { value: "Adoni", label: "ఆదోని" },
    { value: "Alur", label: "ఆలూరు" },
    { value: "Emmiganur", label: "ఎమ్మిగనూరు" },
    { value: "Kodumur", label: "కోడుమూరు" },
    { value: "Pattikonda", label: "పత్తికొండ" },
    { value: "Mantralayam", label: "మంత్రాలయం" },
    { value: "Panyam", label: "పాణ్యం" }
   
  ],
  "mandals": [
    { value: "Kurnool", label: "కర్నూల్" },
    { value: "Devanakonda", label: "దేవనకొండ" },
    { value: "Halaharvi", label: "హాలహర్వి" },
    { value: "Aspari", label: "ఆస్పరి" },
    { value: "Chippagiri", label: "చిప్పగిరి" },
    { value: "Holagunda", label: "హోలగుంద" },
    { value: "Emmiganur", label: "ఎమ్మిగనూరు" },
    { value: "Gonegandla", label: "గోనెగండ్ల" },
    { value: "Nandavaram", label: "నందవరం" },
    { value: "Kurnool Municipal Corporation", label: "కర్నూలు నగరపాలక సంస్థ" },
    { value: "Kodumur", label: "కోడుమూరు" },
    { value: "Guduru", label: "గూడూరు" },
    { value: "C Belagal", label: "సి.బెలగల్" },
    { value: "Krishnagiri", label: "క్రిష్ణగిరి" },
    { value: "Tuggali", label: "తుగ్గలి" },
    { value: "Pattikonda", label: "పత్తికొండ" },
    { value: "Maddikera", label: "మద్దికెర" },
    { value: "Veldurthi", label: "వెల్దుర్తి" },
    { value: "Kosigi", label: "కోసిగి" },
    { value: "Kothalum", label: "కౌతాలం" },
    { value: "Peddakadaburu", label: "పెద్దకడబూరు" },
    { value: "Mantralayam", label: "మంత్రాలయం" },
    { value: "Orvakal", label: "ఓర్వకల్లు" },
    { value: "Kalluru", label: "కల్లూరు" }
  ]
},

    {
  "district_en": "Nandyala",
  "district_te": "నంద్యాల",
  "constituencies": [
    { value: "Nandyal", label: "నంద్యాల" },
    { value: "Allagadda", label: "ఆళ్ళగడ్డ" },
    { value: "Don", label: "డోన్" },
    { value: "Nandikotkur", label: "నందికొట్కూరు" },
    { value: "Panyam", label: "పాణ్యం" },
    { value: "Banaganapalle", label: "బనగానపల్లె" },
    { value: "Srisailam", label: "శ్రీశైలం" }
  ],
  "mandals": [
    { value: "Nandyal", label: "నంద్యాల" },
    { value: "Allagadda", label: "ఆళ్లగడ్డ" },
    { value: "Uyyalawada", label: "ఉయ్యాలవాడ" },
    { value: "Sirivella", label: "శిరివెళ్ళ" },
    { value: "Chagalamarri", label: "చాగలమర్రి" },
    { value: "Dornipadu", label: "దొర్నిపాడు" },
    { value: "Bethancherl", label: "బేతంచర్ల" },
    { value: "Rudravaram", label: "రుద్రవరం" },
    { value: "Don", label: "డోన్" },
    { value: "Kothapalle", label: "కొత్తపల్లె" },
    { value: "Pyapili", label: "ప్యాపిలి" },
    { value: "Juapadu Bangla", label: "జూపాడు బంగ్లా" },
    { value: "Pamulapadu", label: "పాములపాడు" },
    { value: "Pagidyal", label: "పగిడ్యాల" },
    { value: "Gospadu", label: "గోస్పాడు" },
    { value: "Miduthuru", label: "మిడుతూరు" },
    { value: "Gadivemula", label: "గడివేముల" },
    { value: "Okkau", label: "ఔకు" },
    { value: "Sanjamal", label: "సంజామల" },
    { value: "Kolimigundla", label: "కొలిమిగుండ్ల" },
    { value: "Panyam", label: "పాణ్యం" },
    { value: "Koyilakuntla", label: "కోయిలకుంట్ల" },
    { value: "Banaganapalle", label: "బనగానపల్లె" },
    { value: "Atmakur", label: "ఆత్మకూరు" },
    { value: "Srisailam", label: "శ్రీశైలం" },
    { value: "Bandi Atmakur", label: "బండి ఆత్మకూరు" },
    { value: "Velugodu", label: "వెలుగోడు" },
    { value: "Mahanandi", label: "మహానంది" }
  ]
},

  {
  "district_en": "Nellore",
  "district_te": "నెల్లూరు",
  "constituencies": [
    { value: "Nellore", label: "నెల్లూరు" },
    { value: "Atmakur", label: "ఆత్మకూరు" },
    { value: "Kandukur", label: "కందుకూరు" },
    { value: "Udayagiri", label: "ఉదయగిరి" },
    { value: "Kavali", label: "కావలి" },
    { value: "Kovuru", label: "కోవూరు" },
    { value: "Nellore City", label: "నెల్లూరు సిటీ" },
    { value: "Nellore Rural", label: "నెల్లూరు రూరల్" },
    { value: "Sarvepalli", label: "సర్వేపల్లి" }
  ],
  "mandals": [
    { value: "Nellore", label: "నెల్లూరు" },
    { value: "Atmakur", label: "ఆత్మకూరు" },
    { value: "Kandukur", label: "కందుకూరు" },
    { value: "Udayagiri", label: "ఉదయగిరి" },
    { value: "Kavali", label: "కావలి" },
    { value: "Kovuru", label: "కోవూరు" },
    { value: "Nellore City", label: "నెల్లూరు సిటీ" },
    { value: "Nellore Rural", label: "నెల్లూరు రూరల్" },
    { value: "Sarvepalli", label: "సర్వేపల్లి" },
    { value: "Anumasamudrampeta", label: "అనుమసముద్రంపేట" },
    { value: "Anantasagaram", label: "అనంతసాగరం" },
    { value: "Marripadu", label: "మర్రిపాడు" },
    { value: "Chejerla", label: "చేజర్ల" },
    { value: "Sangam", label: "సంగం" },
    { value: "Kaligiri", label: "కలిగిరి" },
    { value: "Kondapuram", label: "కొండాపురం" },
    { value: "Jaladanki", label: "జలదంకి" },
    { value: "Duttalur", label: "దుత్తలూరు" },
    { value: "Varikuntapadu", label: "వరికుంటపాడు" },
    { value: "Seetharamapuram", label: "సీతారామపురం" },
    { value: "Vinjamuru", label: "వింజమూరు" },
    { value: "Lingasamudram", label: "లింగసముద్రము" },
    { value: "Ulavapadu", label: "ఉలవపాడు" },
    { value: "Gudluru", label: "గుడ్లూరు" },
    { value: "Oletivaripalem", label: "ఓలేటివారిపాలెం" },
    { value: "Alluru", label: "అల్లూరు" },
    { value: "Dagadarthi", label: "దగదర్తి" },
    { value: "Bogolu", label: "బోగోలు" },
    { value: "Buchireddipalem", label: "బుచ్చిరెడ్డిపాలెం" },
    { value: "Indukurupet", label: "ఇందుకూరుపేట" },
    { value: "Kodavaluru", label: "కొడవలూరు" },
    { value: "Vidavaluru", label: "విడవలూరు" },
    { value: "Totapalliguduru", label: "తోటపల్లిగూడూరు" },
    { value: "Manubolu", label: "మనుబోలు" },
    { value: "Podalakuru", label: "పొదలకూరు" },
    { value: "Muttukuru", label: "ముత్తుకూరు" },
    { value: "Venkatachalam", label: "వెంకటాచలం" }
  ]
},

  {
  "district_en": "NTR",
  "district_te": "ఎన్టీఆర్",
  "constituencies": [
    { value: "Tenali", label: "తెనాలి" },
    { value: "Jaggayyapeta", label: "జగ్గయపేట" },
    { value: "Tiruvuru", label: "తిరువూరు" },
    { value: "Nandigama", label: "నందిగామ" },
    { value: "Mylavaram", label: "మైలవరం" },
    { value: "Vijayawada West", label: "విజయవాడ వెస్ట్" },
    { value: "Vijayawada Central", label: "విజయవాడ సెంట్రల్" },
    { value: "Vijayawada East", label: "విజయవాడ ఈస్ట్" }
  ],
  "mandals": [
    { value: "Tenali", label: "తెనాలి" },
    { value: "Jaggayyapeta", label: "జగ్గయపేట" },
    { value: "Tiruvuru", label: "తిరువూరు" },
    { value: "Nandigama", label: "నందిగామ" },
    { value: "Mylavaram", label: "మైలవరం" },
    { value: "Vijayawada West", label: "విజయవాడ వెస్ట్" },
    { value: "Vijayawada Central", label: "విజయవాడ సెంట్రల్" },
    { value: "Vijayawada East", label: "విజయవాడ ఈస్ట్" },
    { value: "Vatsavayi", label: "వత్సవాయి" },
    { value: "Penuganchiprolu", label: "పెనుగంచిప్రోలు" },
    { value: "Vissannapeta", label: "విస్సన్నపేట" },
    { value: "Gampalagudem", label: "గంపలగూడెం" },
    { value: "A Konduru", label: "ఏ.కొండూరు" },
    { value: "Kanchikacherla", label: "కంచికచెర్ల" },
    { value: "Veerullapadu", label: "వీరుల్లపాడు" },
    { value: "Chanderlapadu", label: "చందర్లపాడు" },
    { value: "Ibrahimpatnam", label: "ఇబ్రహీంపట్నం" },
    { value: "G Konduru", label: "జి.కొండూరు" },
    { value: "Reddigudem", label: "రెడ్డిగూడెం" },
    { value: "Vijayawada Rural", label: "విజయవాడ గ్రామీణ" }
  ]
},

  {
  "district_en": "Palnadu",
  "district_te": "పలనాడు",
  "constituencies": [
    { value: "Chilakaluripeta", label: "చిలకలూరిపేట" },
    { value: "Narasaraopet", label: "నరసరావుపేట" },
    { value: "Gurajala", label: "గురజాల" },
    { value: "Pedakurapadu", label: "పెదకూరపాడు" },
    { value: "Macherla", label: "మాచెర్ల" },
    { value: "Vinukonda", label: "వినుకొండ" },
    { value: "Sattenapalli", label: "సత్తెనపల్లి" }
  ],
  "mandals": [
    { value: "Gurajala", label: "గురజాల" },
    { value: "Dachepalli", label: "దాచేపల్లి" },
    { value: "Piduguralla", label: "పిడుగురాళ్ళ" },
    { value: "Machavaram", label: "మాచవరం" },
    { value: "Nadendla", label: "నాదెండ్ల" },
    { value: "Chilakaluripeta", label: "చిలకలూరిపేట" },
    { value: "Edlapadu", label: "ఎడ్లపాడు" },
    { value: "Rompicherla", label: "రొంపిచెర్ల" },
    { value: "Narasaraopet", label: "నరసరావుపేట" },
    { value: "Pedakurapadu", label: "పెదకూరపాడు" },
    { value: "Bellamkonda", label: "బెల్లంకొండ" },
    { value: "Achampet", label: "అచ్చంపేట" },
    { value: "Krosuru", label: "క్రోసూరు" },
    { value: "Amaravathi", label: "అమరావతి" },
    { value: "Macherla", label: "మాచెర్ల" },
    { value: "Veldurthi", label: "వెల్దుర్తి" },
    { value: "Durgi", label: "దుర్గి" },
    { value: "Rentachintala", label: "రెంటచింతల" },
    { value: "Karampudi", label: "కారంపూడి" },
    { value: "Bollapalli", label: "బొల్లాపల్లి" },
    { value: "Vinukonda", label: "వినుకొండ" },
    { value: "Nuzendla", label: "నూజెండ్ల" },
    { value: "Shivalyapuram", label: "శావల్యాపురం" },
    { value: "Ipuru", label: "ఈపూరు" },
    { value: "Sattenapalli", label: "సత్తెనపల్లి" },
    { value: "Rajupalem", label: "రాజుపాలెం" },
    { value: "Nakarikallu", label: "నకరికల్లు" },
    { value: "Muppalla", label: "ముప్పాళ్ల" }
  ]
},

  {
  "district_en": "Parvatipuram Manyam",
  "district_te": "పర్వతిపురం మణ్యం",
  "constituencies": [
    { value: "Palakonda", label: "పాలకొండ" },
    { value: "Kurupam", label: "కురుపాం" },
    { value: "Parvatipuram", label: "పార్వతీపురం" },
    { value: "Salur", label: "సాలూరు" }
  ],
  "mandals": [
    { value: "Palakonda", label: "పాలకొండ" },
    { value: "Bhamini", label: "భామిని" },
    { value: "Veeraghattam", label: "వీరఘట్టం" },
    { value: "Seethampeta", label: "సీతంపేట" },
    { value: "Kurupam", label: "కురుపాం" },
    { value: "Komarada", label: "కొమరాడ" },
    { value: "Garugubilli", label: "గరుగుబిల్లి" },
    { value: "Gummalakshmipuram", label: "గుమ్మలక్ష్మీపురం" },
    { value: "Jiyyammavalasa", label: "జియ్యమ్మవలస" },
    { value: "Parvatipuram", label: "పార్వతీపురం" },
    { value: "Seethanagaram", label: "సీతానగరం" },
    { value: "Balijipeta", label: "బలిజిపేట" },
    { value: "Pachipenta", label: "పాచిపెంట" },
    { value: "Makkuva", label: "మక్కువ" },
    { value: "Mentada", label: "మెంటాడ" },
    { value: "Salur", label: "సాలూరు" }
  ]
},

  {
  "district_en": "Prakasam",
  "district_te": "ప్రకాశం",
  "constituencies": [
    { value: "Erragondapalem", label: "ఎర్రగొండపాలెం" },
    { value: "Darsi", label: "దర్శి" },
    { value: "Santhanuthalapadu", label: "సంతనూతలపాడు" },
    { value: "Ongole", label: "ఒంగోలు" },
    { value: "Kondapi", label: "కొండపి" },
    { value: "Markapuram", label: "మార్కాపురం" },
    { value: "Giddalur", label: "గిద్దలూరు" },
    { value: "Kanigiri", label: "కనిగిరి" }
  ],
  "mandals": [
    { value: "Erragondapalem", label: "ఎర్రగొండపాలెం" },{ value: "Pullalacheruvu", label: "పుల్లలచెరువు" },{ value: "Tripurantakam", label: "త్రిపురాంతకం" },
    { value: "Dornala", label: "దోర్నాల" },{ value: "Peddaaraveedu", label: "పెద్దఆరవీడు" },{ value: "Donakonda", label: "దొనకొండ" },
    { value: "Kurichedu", label: "కురిచేడు" },{ value: "Mundlamuru", label: "ముండ్లమూరు" },{ value: "Darsi", label: "దర్శి" },{ value: "Talluru", label: "తాళ్ళూరు" },
    { value: "Naguluppalapadu", label: "నాగులుప్పలపాడు" },{ value: "Maddipadu", label: "మద్దిపాడు" },{ value: "Chemakurthi", label: "చీమకుర్తి" },
    { value: "Santhanuthalapadu", label: "సంతనూతలపాడు" },{ value: "Ongole", label: "ఒంగోలు" },{ value: "Kottapatnam", label: "కొత్తపట్నం" },
    { value: "Singarayakonda", label: "సింగరాయకొండ" },{ value: "Kondapi", label: "కొండపి" },{ value: "Tanguturu", label: "టంగుటూరు" },
    { value: "Jarugumalli", label: "జరుగుమల్లి" },{ value: "Ponnaluru", label: "పొన్నలూరు" },{ value: "Marripudi", label: "మర్రిపూడి" },
    { value: "Konakanamitla", label: "కొనకనమిట్ల" },{ value: "Podili", label: "పొదిలి" },{ value: "Tarlupadu", label: "తర్లుపాడు" },
    { value: "Ardhaveedu", label: "అర్ధవీడు" },{ value: "Bestavaripeta", label: "బేస్తవారిపేట" },{ value: "Racharla", label: "రాచర్ల" },
    { value: "Giddalur", label: "గిద్దలూరు" },{ value: "Komarolu", label: "కొమరోలు" },{ value: "Kambham", label: "కంభం" },
    { value: "Hanumanthunipadu", label: "హనుమంతునిపాడు" },{ value: "Chandrashekharapuram", label: "చంద్రశేఖరపురం" },{ value: "Pamuru", label: "పామూరు" },
    { value: "Veligandla", label: "వెలిగండ్ల" },{ value: "Peddacherlopalli", label: "పెదచెర్లోపల్లి" },{ value: "Kanigiri", label: "కనిగిరి" }
  ]
},

  {
  "district_en": "Sri Satya Sai",
  "district_te": "శ్రీ సత్య సాయి",
  "constituencies": [
    { value: "Madakasira", label: "మడకశిర" },{ value: "Hindupur", label: "హిందూపురం" },{ value: "Penukonda", label: "పెనుకొండ" },
    { value: "Puttaparthi", label: "పుట్టపర్తి" },{ value: "Dharmavaram", label: "ధర్మవరం" },{ value: "Kadiri", label: "కదిరి" }
  ],
  "mandals": [
    { value: "Agali", label: "అగలి" },{ value: "Amarapuram", label: "అమరాపురం" },{ value: "Gudibanda", label: "గుడిబండ" },
    { value: "Madakasira", label: "మడకశిర" },{ value: "Roll", label: "రొల్ల" },{ value: "Chilamatturu", label: "చిలమత్తూరు" },
    { value: "Lepakshi", label: "లేపాక్షి" },{ value: "Hindupur", label: "హిందూపురం" },{ value: "Gorantla", label: "గోరంట్ల" },
    { value: "Parigi", label: "పరిగి" },{ value: "Penukonda", label: "పెనుకొండ" },{ value: "Roddum", label: "రొద్దం" },
    { value: "Somandepalle", label: "సోమందేపల్లె" },{ value: "Obuladevaracheruvu_ODC", label: "ఓబులదేవరచెరువు(ఓ.డి.సి)" },
    { value: "Amadaguru", label: "అమడగూరు" },{ value: "Kottacheruvu", label: "కొత్తచెరువు" },{ value: "Nallamadda", label: "నల్లమాడ" },
    { value: "Puttaparthi", label: "పుట్టపర్తి" },{ value: "Bukkapatnam", label: "బుక్కపట్నం" },{ value: "Dharmavaram", label: "ధర్మవరం" },
    { value: "Battalapalle", label: "బత్తలపల్లి" },{ value: "Tadimarri", label: "తాడిమర్రి" },{ value: "Mudigubba", label: "ముదిగుబ్బ" },
    { value: "Kadiri", label: "కదిరి" },{ value: "Gandlapenta", label: "గాండ్లపెంట" },{ value: "Tanakallu", label: "తనకల్లు" },
    { value: "Talupula", label: "తలుపుల" },{ value: "Nallacheruvu", label: "నల్లచెరువు" },{ value: "Nambulapoolakunta", label: "నంబులపూలకుంట" }
  ]
},

  {
  "district_en": "Srikakulam",
  "district_te": "శ్రీకాకుళం",
  "constituencies": [
    { value: "Ichchapuram", label: "ఇచ్ఛాపురం" },{ value: "Palasa", label: "పలాస" },
    { value: "Tekkali", label: "టెక్కలి" },{ value: "Pattapatnam", label: "పాతపట్నం" },{ value: "Srikakulam", label: "శ్రీకాకుళం" },
    { value: "Amudalavalasa", label: "ఆముదాలవలస" },{ value: "Etcherla", label: "ఎచ్చెర్ల" },{ value: "Narasannapeta", label: "నరసన్నపేట" }
  ],
  "mandals": [
    { value: "Ichchapuram", label: "ఇచ్ఛాపురం" },{ value: "Kaviti", label: "కవిటి" },{ value: "Kanchili", label: "కంచిలి" },{ value: "Sompeta", label: "సోంపేట" },
    { value: "Palasa", label: "పలాస" },{ value: "Mandasa", label: "మందస" },{ value: "Vajrapukotturu", label: "వజ్రపుకొత్తూరు" },
    { value: "Kotabommali", label: "కోటబొమ్మాళి" },{ value: "Tekkali", label: "టెక్కలి" },{ value: "Nandigam", label: "నందిగం" },
    { value: "Santabommali", label: "సంతబొమ్మాళి" },{ value: "Kothuru", label: "కొత్తూరు" },{ value: "Pattapatnam", label: "పాతపట్నం" },
    { value: "Meliyaputti", label: "మెళియాపుట్టి" },{ value: "Lakshminarsupeta", label: "లక్ష్మీనర్సుపేట" },{ value: "Hiramandalam", label: "హిరమండలం" },
    { value: "Srikakulam", label: "శ్రీకాకుళం" },{ value: "Gara Mandalam", label: "గార మండలం" },{ value: "Amudalavalasa", label: "ఆముదాలవలస" },
    { value: "Ponduru", label: "పొందూరు" },{ value: "Burja", label: "బూర్జ" },{ value: "Sarubujjili", label: "సరుబుజ్జిలి" },
    { value: "Ranasthalam", label: "రణస్థలం" },{ value: "Laveru", label: "లావేరు" },{ value: "Jalumuru", label: "జలుమూరు" },
    { value: "Polaki", label: "పొలాకి" },{ value: "Saravakota", label: "సారవకోట" },{ value: "Rajam", label: "రాజాం" },
    { value: "Regidi Amudalavalasa", label: "రేగిడి ఆముదాలవలస" },{ value: "Vangara", label: "వంగర" },{ value: "Santakaviti", label: "సంతకవిటి" }
  ]
},

  {
  "district_en": "Tirupati",
  "district_te": "తిరుపతి",
  "constituencies": [
    { value: "Guduru", label: "గూడూరు" },{ value: "Chandragiri", label: "చంద్రగిరి" },
    { value: "Tirupati", label: "తిరుపతి" },{ value: "Venkatachalam", label: "వెంకటగిరి" },
    { value: "Srikalahasti", label: "శ్రీకాళహస్తి" },{ value: "Satyavedu", label: "సత్యవేడు" },{ value: "Sullurupeta", label: "సూళ్ళూరుపేట" }
  ],
  "mandals": [
    { value: "Kota", label: "కోట" },{ value: "Guduru", label: "గూడూరు" },{ value: "Chittamuru", label: "చిట్టమూరు" },{ value: "Chillakuru", label: "చిల్లకూరు" },
    { value: "Vakadu", label: "వాకాడు" },{ value: "Chinnagottigallu", label: "చిన్నగొట్టిగల్లు" },{ value: "Chandragiri", label: "చంద్రగిరి" },
    { value: "Tirupati Rural", label: "తిరుపతి గ్రామీణ" },{ value: "Tirupati Urban", label: "తిరుపతి (పట్టణ)" },{ value: "Pakala", label: "పాకాల" },
    { value: "Yerravaripalem", label: "యెర్రావారిపాలెం" },{ value: "Ramachandrapuram (Chittoor)", label: "రామచంద్రాపురం(చిత్తూరు)" },
    { value: "Kaluvaayi (Nellore Dist)", label: "కలువాయి(నెల్లూరు జిల్ల)" },{ value: "Raapur (Nellore Dist)", label: "రాపూరు(నెల్లూరు జిల్ల)" },
    { value: "Saidapuram (Nellore Dist)", label: "సైదాపురం(నెల్లూరు జిల్ల)" },{ value: "Dakkili (Tirupati Dist)", label: "డక్కిలి(తిరుపతి జిల్లా)" },{ value: "Venkatachalam (Tirupati Dist)", label: "వెంకటగిరి(తిరుపతి జిల్లా)" },
    { value: "Balayapalle (Tirupati Dist)", label: "బాలాయపల్లె(తిరుపతి జిల్లా)" },{ value: "Erpedu", label: "ఏర్పేడు" },{ value: "Thottambedu", label: "తొట్టంబేడు" },
    { value: "Renigunta", label: "రేణిగుంట" },{ value: "KVB Puram", label: "కె.వి.బి.పురం" },{ value: "Nagalapuram", label: "నాగలాపురం" },
    { value: "Narayana Vanam", label: "నారాయణవనం" },{ value: "Picchatur", label: "పిచ్చాటూరు" },{ value: "Buchchinaidu Khandrig", label: "బుచ్చినాయుడు ఖండ్రిగ" },
    { value: "Varadayyapalem", label: "వరదయ్యపాలెం" },{ value: "Ojili", label: "ఓజిలి" },{ value: "Tada", label: "తడ" },
    { value: "Doravarisatram", label: "దొరవారిసత్రం" },{ value: "Naidupeta", label: "నాయుడుపేట" },{ value: "Pellakuru", label: "పెళ్లకూరు" }
  ]
},

  {
  "district_en": "Vizianagaram",
  "district_te": "విజయనగరం",
  "constituencies": [
    { value: "Rajam", label: "రాజాం" },{ value: "Bobbili", label: "బొబ్బిలి" },{ value: "Cheepurupalli", label: "చీపురుపల్లి" },{ value: "Gajapathinagaram", label: "గజపతినగరం" },
    { value: "Nellimarla", label: "నెల్లిమర్ల" },{ value: "Vijayanagaram", label: "విజయనగరం" },{ value: "Srungavarapukota", label: "శృంగవరపుకోట" }
  ],
  "mandals": [
    { value: "Rajam", label: "రాజాం" },{ value: "Regidi Amudalavalasa", label: "రేగిడి ఆముదాలవలస" },
    { value: "Vangara", label: "వంగర" },{ value: "Santakaviti", label: "సంతకవిటి" },{ value: "Terlama", label: "తెర్లాం" },
    { value: "Badangi", label: "బాడంగి" },{ value: "Bobbili", label: "బొబ్బిలి" },{ value: "Ramabhadrapuram", label: "రామభద్రపురం" },
    { value: "Garividi", label: "గరివిడి" },{ value: "Gurla", label: "గుర్ల" },{ value: "Cheepurupalli", label: "చీపురుపల్లి" },
    { value: "Merakamudidam", label: "మెరకముడిదాం" },{ value: "Gajapathinagaram", label: "గజపతినగరం" },{ value: "Gantyada", label: "గంట్యాడ" },
    { value: "Jami", label: "జామి" },{ value: "Dattirajeru", label: "దత్తిరాజేరు" },{ value: "Bondapalle", label: "బొండపల్లి" },
    { value: "Denkada", label: "డెంకాడ" },{ value: "Nellimarla", label: "నెల్లిమర్ల" },{ value: "Poosapatirega", label: "పూసపాటిరేగ" },
    { value: "Bhogapuram", label: "భోగాపురం" },{ value: "Vijayanagaram", label: "విజయనగరం" },{ value: "Srungavarapukota", label: "శృంగవరపుకోట" },
    { value: "Vepada", label: "వేపాడ" },{ value: "Lakkavarapukota", label: "లక్కవరపుకోట" },{ value: "Kothavalasa", label: "కొత్తవలస" }
  ]
},

  {
  "district_en": "Visakhapatnam",
  "district_te": "విశాఖపట్టణం",
  "constituencies": [
    { value: "Bhimili", label: "భీమిలి" },{ value: "Visakhapatnam East", label: "విశాఖపట్నం తూర్పు" },{ value: "Visakhapatnam South", label: "విశాఖపట్నం సౌత్" },
    { value: "Visakhapatnam North", label: "విశాఖపట్నం నార్త్" },{ value: "Visakhapatnam West", label: "విశాఖపట్నం వెస్ట్" },{ value: "Gajuwaka", label: "గాజువాక" }
  ],
  "mandals": [
    { value: "Bhimili", label: "భీమిలి" },{ value: "Anandapuram", label: "ఆనందపురం" },{ value: "Padmanabham", label: "పద్మనాభం" },
    { value: "Visakhapatnam Rural", label: "విశాఖపట్నం రూరల్" },{ value: "Visakhapatnam East", label: "విశాఖపట్నం తూర్పు" },{ value: "Visakhapatnam South", label: "విశాఖపట్నం సౌత్" },
    { value: "Visakhapatnam North", label: "విశాఖపట్నం నార్త్" },{ value: "Visakhapatnam West", label: "విశాఖపట్నం వెస్ట్" },{ value: "Gajuwaka", label: "గాజువాక" }
  ]
},

  {
  "district_en": "West Godavari",
  "district_te": "పశ్చిమ గోదావరీ",
  "constituencies": [
    { value: "Achanta", label: "ఆచంట" },{ value: "Palakollu", label: "పాలకొల్లు" },{ value: "Narsapuram", label: "నర్సాపురం" },{ value: "Bhimavaram", label: "భీమవరం" },
    { value: "Undi", label: "ఉండి" },{ value: "Tanuku", label: "తణుకు" },{ value: "Tadepalligudem", label: "తాడేపల్లిగూడెం" }
  ],
  "mandals": [
    { value: "Achanta", label: "ఆచంట" },{ value: "Penugonda", label: "పెనుగొండ" },{ value: "Penumantra", label: "పెనుమంట్ర" },{ value: "Poduru", label: "పోడురు" },
    { value: "Yelamanchili", label: "యలమంచిలి" },{ value: "Palakollu", label: "పాలకొల్లు" },{ value: "Narsapuram", label: "నరసాపురం" },
    { value: "Bhimavaram", label: "భీమవరం" },{ value: "Mogalturu", label: "మొగల్తూరు" },{ value: "Veeravasaram", label: "వీరవాసరం" },
    { value: "Akiveedu", label: "ఆకివీడు" },{ value: "Undi", label: "ఉండి" },{ value: "Kalla", label: "కాళ్ళ" },
    { value: "Palakoderu", label: "పాలకోడేరు" },{ value: "Attili", label: "అత్తిలి" },{ value: "Iragavaram", label: "ఇరగవరం" },
    { value: "Tanuku", label: "తణుకు" },{ value: "Tadepalligudem", label: "తాడేపల్లిగూడెం" },{ value: "Pentapadu", label: "పెంటపాడు" }
  ]
},
]
  },
 ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  {
    state_en: "Telangana",
    state_te: "తెలంగాణ",
    districts: [
    {
      "district_en": "Asifabad",
  "district_te": "ఆసిఫాబాద్",
  "constituencies": [
    { value: "Asifabad", label: "ఆసిఫాబాద్" },
  ],
  "mandals": [
    { value: "Kerameri", label: "కెరమెరి" },{ value: "Vankidi", label: "వాంకిడి" },{ value: "Sirpur Town", label: "సిర్పూర్ పట్టణ" },
    { value: "Asifabad", label: "ఆసిఫాబాద్" },{ value: "Jainoor", label: "జైనూర్" },{ value: "Tiryani", label: "తిర్యాని" },
    { value: "Rebbena", label: "రెబ్బెన" },{ value: "Narnur", label: "నార్నూర్" },{ value: "Lingapur", label: "లింగాపూర్" }
  ],
  "district_en": "Adilabad",
  "district_te": "ఆదిలాబాద్",
  "constituencies": [
    { value: "Nirmal", label: "నిర్మల్" },
  { value: "Mudhol", label: "ముధోల్" },
  { value: "Sirpur", label: "సిర్పూర్" },
  { value: "Asifabad", label: "ఆసిఫాబాద్" },
  { value: "Khanapur", label: "ఖానాపూర్" },
  { value: "Adilabad", label: "ఆదిలాబాదు" },
  { value: "Bodh", label: "బోథ్" }
  ],
  "mandals": [
    { value: "Dilawar Pur", label: "దిలావర్ పూర్" },{ value: "Nirmal", label: "నిర్మల్" },{ value: "Lakshmanchanda", label: "లక్ష్మణ్‌చందా" },{ value: "Mamda", label: "మామడ" },
{ value: "Sarangapur", label: "సారంగాపూర్" },{ value: "Nirmal Town", label: "నిర్మల్ టౌన్" },{ value: "Nirmal Rural", label: "నిర్మల్ రూరల్" },{ value: "Narsapur (G)", label: "నర్సాపూర్ (జి)" },
{ value: "Son", label: "సోన్" },{ value: "Kuntala", label: "కుంటాల" },{ value: "Kubeer", label: "కుభీర్" },{ value: "Bhainsa", label: "భైంసా" },
{ value: "Tanur", label: "తానూర్" },{ value: "Mudhol", label: "ముధోల్" },{ value: "Lokeswaram", label: "లోకేశ్వరం" },{ value: "Kouthala", label: "కౌతల" },
{ value: "Bejjur", label: "బెజ్జూర్‌" },{ value: "Kagaznagar", label: "కాగజ్‌నగర్‌" },{ value: "Sirpur", label: "సిర్పూర్" },
{ value: "Dahegaon", label: "దహేగావ్‌" },{ value: "Penchikalpet", label: "పెంచికల్ పేట్" },{ value: "Chintalamanepally", label: "చింతల మానేపల్లి" },
{ value: "Kerameri", label: "కెరమెరి మండలం" },
  { value: "Wankidi", label: "వాంకిడి మండలం" },{ value: "Sirpur Town", label: "సిర్పూర్ పట్టణ మండలం" },{ value: "Asifabad", label: "ఆసిఫాబాద్ మండలం" },
  { value: "Jainoor", label: "జైనూర్ మండలం" },{ value: "Tiryani", label: "తిర్యాని మండలం" },{ value: "Rebbena", label: "రెబ్బెన మండలం" },{ value: "Narnur", label: "నార్నూర్ మండలం" },
  { value: "Lingapur", label: "లింగాపూర్ మండలం" },{ value: "Jannaram", label: "జన్నారం" },{ value: "Utnoor", label: "ఉట్నూర్" },{ value: "Kadem (Peddur)", label: "కడెం (పెద్దూర్)" },
  { value: "Khanapur", label: "ఖానాపూర్" },{ value: "Indravelli", label: "ఇంద్రవెల్లి" },{ value: "Adilabad", label: "ఆదిలాబాదు" },{ value: "Jainath", label: "జైనథ్" },
  { value: "Bela", label: "బేల" },{ value: "Tamsi", label: "తాంసీ" },{ value: "Talamadugu", label: "తలమడుగు" },{ value: "Gudihatnur", label: "గుడిహథ్నూర్" },
  { value: "Ichoda", label: "ఇచ్చోడ" },{ value: "Bazarhathnur", label: "బజార్‌హథ్నూర్" },{ value: "Bodh", label: "బోథ్" },{ value: "Neradigonda", label: "నేరెడిగొండ" }

  ]
},
    {
  "district_en": "Bhadradri Kothagudem",
  "district_te": "భద్రాద్రి కొత్తగూడెం",
  "constituencies": [
    { value: "Illandu", label: "ఇల్లందు" },
    { value: "Vaira", label: "వైరా" },
    { value: "Kothagudem", label: "కొత్తగూడెం" },
    { value: "Ashwaraopeta", label: "అశ్వారావుపేట" },
    { value: "Bhadrachalam", label: "భద్రాచలం" }
  ],
  "mandals": [
    { value: "Illandu", label: "ఇల్లందు" },
{ value: "Bayyaram", label: "బయ్యారం" },
{ value: "Garla", label: "గార్ల" },
{ value: "Singareni", label: "సింగరేణి" },
{ value: "Tekulapalli", label: "టేకులపల్లి" },
{ value: "Kamepalli", label: "కామేపల్లి" },
{ value: "Enkoor", label: "ఎంకూరు" },
{ value: "Konijerla", label: "కొణిజెర్ల" },
{ value: "Tallada", label: "తల్లాడ" },
{ value: "Vaira", label: "వైరా" },
{ value: "Kothagudem", label: "కొత్తగూడెం" },
{ value: "Palvancha", label: "పాల్వంచ" },
{ value: "Sujathanagar", label: "సుజాతనగర్" },
{ value: "Chunchupalli", label: "చుంచుపల్లి" },
{ value: "Lakshmidevipalli", label: "లక్ష్మీదేవిపల్లి" },
{ value: "Dummapeta", label: "దమ్మపేట" },
{ value: "Chandrugonda", label: "చంద్రుగొండ" },
{ value: "Mulkalapalli", label: "ముల్కలపల్లి" },
{ value: "Kukunuru", label: "కుక్కునూరు" },
{ value: "Ashwaraopeta", label: "అశ్వారావుపేట" },
{ value: "Venkatapuram", label: "వెంకటాపురం" },
{ value: "Cherla", label: "చెర్ల" },
{ value: "Dummugudem", label: "దుమ్ముగూడెం" },
{ value: "Bhadrachalam", label: "భద్రాచలం" }
  ]
},
    {
  "district_en": "Hanumakonda",
  "district_te": "హనుమకొండ",
  "constituencies": [
    { value: "Husnabad", label: "హుస్నాబాద్" },
    { value: "Parakala", label: "పరకాల" },
    { value: "PashchimaWarangal", label: "పశ్చిమ వరంగల్" },
    { value: "ToorpuWarangal", label: "తూర్పు వరంగల్" }
  ],
  "mandals": [
    { value: "Chigurumamidi", label: "చిగురుమామిడి" },
    { value: "Koheda", label: "కోహెడ" },
    { value: "Husnabad", label: "హుస్నాబాద్" },
    { value: "Saidapur", label: "సైదాపూర్" },
    { value: "Bheemadevarapalli", label: "భీమదేవరపల్లి" },
    { value: "Elkathurthi", label: "ఎల్కతుర్తి" },
    { value: "Parakala", label: "పరకాల" },
    { value: "Atmakur", label: "ఆత్మకూరు" },
    { value: "Sangem", label: "సంగెం" },
    { value: "Geegonda", label: "గీసుగొండ" },
    { value: "Nadikuda", label: "నడికుడా" },
    { value: "Damera", label: "దామెర" },
    { value: "WarangalMandal", label: "వరంగల్ మండలం" },
    { value: "WarangalCorporation", label: "వరంగల్ కార్పోరేషన్" }
  ]
},

{
  "district_en": "Hyderabad",
  "district_te": "హైదరాబాద్",
  "constituencies": [
    { value: "Musheerabad", label: "ముషీరాబాద్" },{ value: "Malakpet", label: "మలక్‌పేట్" },{ value: "Amberpet", label: "అంబర్‌పేట్" },
  { value: "Osmania University", label: "ఉస్మానియా విశ్వవిద్యాలయం" },{ value: "Khairatabad", label: "ఖైరతాబాదు" },{ value: "Jubilee Hills", label: "జూబ్లీహిల్స్" },
  { value: "Sanathnagar", label: "సనత్‌నగర్" },{ value: "Nampally", label: "నాంపల్లి" },{ value: "Karwan", label: "కార్వాన్" },
  { value: "Goshamahal", label: "గోషమహల్" },{ value: "Charminar", label: "చార్మినార్" },{ value: "Chandrayangutta", label: "చాంద్రాయణగుట్ట" },
  { value: "Yakutpura", label: "యాకుత్‌పురా" },{ value: "Bahadurpura", label: "బహదూర్‌పూరా" },{ value: "Secunderabad", label: "సికింద్రాబాద్" },
  { value: "Secunderabad Cantonment", label: "సికింద్రాబాద్ కంటోన్మెంట్" }
  ],
  "mandals": [
    { value: "Musheerabad", label: "ముషీరాబాద్" },{ value: "Malakpet", label: "మలక్‌పేట్" },{ value: "Amberpet", label: "అంబర్‌పేట్" },
  { value: "Osmania University", label: "ఉస్మానియా విశ్వవిద్యాలయం" },{ value: "Khairatabad", label: "ఖైరతాబాదు" },{ value: "Jubilee Hills", label: "జూబ్లీహిల్స్" },
  { value: "Sanathnagar", label: "సనత్‌నగర్" },{ value: "Nampally", label: "నాంపల్లి" },{ value: "Karwan", label: "కార్వాన్" },
  { value: "Goshamahal", label: "గోషమహల్" },{ value: "Charminar", label: "చార్మినార్" },{ value: "Chandrayangutta", label: "చాంద్రాయణగుట్ట" },
  { value: "Yakutpura", label: "యాకుత్‌పురా" },{ value: "Bahadurpura", label: "బహదూర్‌పూరా" },{ value: "Secunderabad", label: "సికింద్రాబాద్" },
  { value: "Secunderabad Cantonment", label: "సికింద్రాబాద్ కంటోన్మెంట్" },{ value: "Masab Tank", label: "మాసబ్ ట్యాంక్" },{ value: "Asifnagar", label: "ఆసిఫ్‌నగర్" },
  { value: "Saifabad", label: "సైఫాబాద్" },{ value: "Mallepalli", label: "మల్లేపల్లి" },{ value: "Chintal Basti", label: "చింతల్ బస్తీ" },
  { value: "Gudimalkapur", label: "గుడిమల్కాపూర్" },{ value: "Madannapet", label: "మాదన్నపేట్" },
  { value: "Dabeerpur", label: "దాబీర్ పుర" },{ value: "Lal Darwaza", label: "లాల్ దర్వాజా" },{ value: "Uppuguda", label: "ఉప్పుగూడ" }
  ]
},

{
  "district_en": "Jagtial",
  "district_te": "జగిత్యాల",
  "constituencies": [
    { value: "Korutla", label: "కోరుట్ల" },{ value: "Jagtial", label: "జగిత్యాల" },
    { value: "Dharmapuri", label: "ధర్మపురి" },{ value: "Choppadandi", label: "చొప్పదండి" },{ value: "Vemulawada", label: "వేములవాడ" }
  ],
  "mandals": [
    { value: "Ibrahimpatnam", label: "ఇబ్రహీంపట్నం" },{ value: "Mallapur", label: "మల్లాపూర్" },{ value: "Korutla", label: "కోరుట్ల" },
{ value: "Metpalli", label: "మెట్‌పల్లి" },{ value: "Raikal", label: "రాయికల్" },{ value: "Sarangapur", label: "సారంగాపూర్" },
{ value: "Jagtial", label: "జగిత్యాల" },{ value: "Dharmapuri", label: "ధర్మపురి" },{ value: "Dharmaram", label: "ధర్మారం" },
{ value: "Gollapalli", label: "గొల్లపల్లి" },{ value: "Velgatoor", label: "వెలగటూర్" },{ value: "Pegadapalli", label: "పెగడపల్లి" },
{ value: "Buggaram", label: "బుగ్గారం" },{ value: "Gangadhara", label: "గంగాధర" },{ value: "Ramagundam", label: "రామడుగు" },
{ value: "Choppadandi", label: "చొప్పదండి" },{ value: "Malyala", label: "మల్యాల" },{ value: "Kodimial", label: "కొడిమియాల్" },
{ value: "Boinpalli", label: "బోయినపల్లి" },{ value: "Vemulawada", label: "వేములవాడ" },{ value: "Konaraopet", label: "కోనరావుపేట" },
{ value: "Chandurthi", label: "చందుర్తి" },{ value: "Kathalapur", label: "కథలాపూర్" },{ value: "Medipalli", label: "మేడిపల్లి" }

  ]
},

{
  "district_en": "Jangaon",
  "district_te": "జగన్",
  "constituencies": [
    { value: "Aleru", label: "ఆలేరు" },{ value: "Jangaon", label: "జనగామ" },
{ value: "GhanpurStation", label: "ఘన్‌పూర్ స్టేషన్" },{ value: "Palakurthi", label: "పాలకుర్తి" }

  ],
  "mandals": [
    { value: "Aleru", label: "ఆలేరు" },{ value: "Yadagirigutta", label: "యాదగిరి గుట్ట" },{ value: "Turkapalli", label: "తుర్కపల్లి" },
{ value: "Rajapet", label: "రాజాపేట" },{ value: "Gundala", label: "గుండాల" },{ value: "Bommalaramaram", label: "బొమ్మలరామారం" },
{ value: "AtmakurM", label: "ఆత్మకూరు(M)" },{ value: "Cheriyal", label: "చేర్యాల" },{ value: "Bachannapet", label: "బచ్చన్నపేట" },
{ value: "Narmetta", label: "నర్మెట్ట" },{ value: "Jangaon", label: "జనగాం" },{ value: "Maddur", label: "మద్దూరు" },
{ value: "Tharigoppula", label: "తరిగిప్పుల" },{ value: "Komuravelli", label: "కొమురవెల్లి" },{ value: "Dharmmetta", label: "ధూల్మిట్ట" },{ value: "StationGhanpur", label: "స్టేషన్ ఘన్‌పూర్" },
{ value: "Dharmasagar", label: "ధర్మసాగర్" },{ value: "Raghunathpalle", label: "రఘునాథ్‌పల్లె" },{ value: "Lingalaghanpur", label: "లింగాలఘన్‌పూర్" },
{ value: "Palakurthi", label: "పాలకుర్తి" },{ value: "Devaruppula", label: "దేవరుప్పుల" },{ value: "Kodakandla", label: "కొడకండ్ల" },
{ value: "Raiparthy", label: "రాయిపర్తి" },{ value: "Thorrur", label: "తొర్రూర్" },{ value: "Peddavangara", label: "పెద్ద వంగర" }
  ]
},

{
  "district_en": "Jayashankar Bhupalapally",
  "district_te": "జయశంకర్ భూపాలపల్లి",
  "constituencies": [
    { value: "Manthani", label: "మంథని" },{ value: "Bhoopalapalli", label: "భూపాలపల్లి" },{ value: "Bhadrachalam", label: "భద్రాచలం" }
  ],
  "mandals": [
    { value: "Kamanupur", label: "కమానుపూర్" },{ value: "Manthani", label: "మంథని" },{ value: "Katarm", label: "కాటారం" },{ value: "Mahadevpur", label: "మహాదేవపూర్" },
{ value: "Muttaram", label: "ముత్తారం" },{ value: "MalharRao", label: "మల్‌హర్‌రావు" },{ value: "MahaMuttaram", label: "మహా ముత్తారం" },
{ value: "Palimela", label: "పలిమెల" },{ value: "Ramagiri", label: "రామగిరి" },{ value: "Mogullapalli", label: "మొగుళ్ళపల్లి" },{ value: "Chityal", label: "చిట్యాల" },
{ value: "Bhoopalapalli", label: "భూపాలపల్లి" },{ value: "Ghanpur", label: "ఘన్‌పూర్" },{ value: "Regonda", label: "రేగొండ" },{ value: "Shaimpet", label: "శాయంపేట" },
{ value: "Venkatapuram", label: "వెంకటాపురం" },{ value: "Cherla", label: "చెర్ల" },{ value: "Dummugudem", label: "దుమ్ముగూడెం" },{ value: "Bhadrachalam", label: "భద్రాచలం" }
  ]
},

{
  "district_en": "Jogulamba Gadwal",
  "district_te": "జోగులాంబ గద్వాల్",
  "constituencies": [
    { value: "Gadwal", label: "గద్వాల" },{ value: "Alampur", label: "అలంపూర్" }
  ],
  "mandals": [
    { value: "Gadwal", label: "గద్వాల" },{ value: "Dharur", label: "ధరూర్" },{ value: "Maldakal", label: "మల్దకల్" },
{ value: "Ghattu", label: "ఘట్టు" },{ value: "Alampur", label: "అలంపూర్" },{ value: "Vaddepalli", label: "వడ్డేపల్లి" },
{ value: "Rajoli", label: "రాజోలి" },{ value: "Itikyala", label: "ఇటిక్యాల" },{ value: "Ayiz", label: "అయిజ" },
{ value: "Manavapadu", label: "మానవపాడు" },{ value: "Undavelli", label: "ఉండవెల్లి" }
  ]
},

  {
    "district_en": "Kamareddy",
    "district_te": "కామారెడ్డి",
    "constituencies": [
      { value: "Jukkal", label: "జుక్కల్" },{ value: "Bansuwada", label: "బాన్సువాడ" },
      { value: "Ellareddy", label: "ఎల్లారెడ్డి" },{ value: "Kamareddy", label: "కామారెడ్డి" }
    ],
    "mandals": [
      { value: "Jukkal", label: "జుక్కల్" },{ value: "Bansuwada", label: "బాన్సువాడ" },{ value: "Birkur", label: "బిర్కూరు" },{ value: "Narsullabad", label: "నర్సుల్లాబాద్" },
{ value: "Vami", label: "వామి" },{ value: "Kotagiri", label: "కోటగిరి" },{ value: "Rudrur", label: "రుద్రూరు" },{ value: "Chandur", label: "చందూరు" },
{ value: "Mosra", label: "మోస్రా" },{ value: "Potangal", label: "పోతంగల్" },{ value: "Ellareddy", label: "ఎల్లారెడ్డి" },{ value: "Kamareddy", label: "కామారెడ్డి" }
    ]
  },
  {
    "district_en": "Karimnagar",
    "district_te": "కరీంనగర్",
    "constituencies": [
      { value: "Karimnagar", label: "కరీంనగర్" },{ value: "Choppadandi", label: "చొప్పదండి" },
{ value: "Manakondur", label: "మానకొండూరు" },{ value: "Huzurabad", label: "హుజురాబాద్" },{ value: "Husnabad", label: "హుస్నాబాద్" }
    ],
    "mandals": [
      { value: "KarimnagarRural", label: "కరీంనగర్ రూరల్" },
{ value: "Kothapalli", label: "కొత్తపల్లి" },{ value: "Gangadhara", label: "గంగాధర" },{ value: "Ramagundam", label: "రామడుగు" },{ value: "Choppadandi", label: "చొప్పదండి" },
{ value: "Malyala", label: "మల్యాల" },{ value: "Kodimial", label: "కొడిమియాల్" },{ value: "Boinpalli", label: "బోయినపల్లి" },
{ value: "Manakondur", label: "మానకొండూరు" },{ value: "Illanthakunta", label: "ఇల్లంతకుంట" },{ value: "Bejjanki", label: "బెజ్జంకి" },
{ value: "Timmapur", label: "తిమ్మాపూర్" },{ value: "Shankarapet", label: "శంకరపట్నం" },{ value: "Ganneruvaram", label: "గన్నేరువరం" },
{ value: "Veenavanka", label: "వీణవంక" },{ value: "Jammikunta", label: "జమ్మికుంట" },{ value: "Huzurabad", label: "హుజురాబాద్" },
{ value: "Kamalapur", label: "కమలాపూర్" },{ value: "Illandhunkunta", label: "ఇల్లందుకుంట" },{ value: "Akkannapet", label: "అక్కన్నపేట్" },
{ value: "Chigurumamidi", label: "చిగురుమామిడి" },{ value: "Kohed", label: "కోహెడ" },{ value: "Husnabad", label: "హుస్నాబాద్" },
{ value: "Saidapur", label: "సైదాపూర్" },{ value: "Bheemadevarpalli", label: "భీమదేవరపల్లి" },{ value: "Elkaturthi", label: "ఎల్కతుర్తి" }
    ]
  },

{
    "district_en": "Khammam",
    "district_te": "ఖమ్మం",
    "constituencies": [
      { value: "Khammam", label: "ఖమ్మం" },{ value: "Paleru", label: "పాలేరు" },{ value: "Madhira", label: "మధిర" },
      { value: "Vaira", label: "వైరా" },{ value: "Sathupalli", label: "సత్తుపల్లి" }
    ],
    "mandals": [
      { value: "KhammamUrban", label: "ఖమ్మం అర్బన్" },{ value: "KhammamRural", label: "ఖమ్మం రూరల్" },
{ value: "Tirumalayapalem", label: "తిరుమలాయపాలెం" },{ value: "Kusumanchi", label: "కూసుమంచి" },{ value: "Nelakondapalli", label: "నేలకొండపల్లి" },
{ value: "KhammamGrameena", label: "ఖమ్మం గ్రామీణ" },{ value: "Mudigonda", label: "ముదిగొండ" },{ value: "Chintakani", label: "చింతకాని" },{ value: "Bonakal", label: "బొనకల్" },
{ value: "Madhira", label: "మధిర" },{ value: "Yerrupalem", label: "యెర్రుపాలెం" },{ value: "Kamepalli", label: "కామేపల్లి" },{ value: "Enkuru", label: "ఎంకూరు" },
{ value: "Konijeral", label: "కొణిజెర్ల" },{ value: "Tallada", label: "తల్లాడ" },{ value: "Vaira", label: "వైరా" },{ value: "Chandrugonda", label: "చంద్రుగొండ" },
{ value: "Sathupalli", label: "సత్తుపల్లి" },{ value: "Penuballi", label: "పెనుబల్లి" },{ value: "Kalluru", label: "కల్లూరు" },{ value: "Vemsuru", label: "వెంసూరు" }
    ]
  },

{
    "district_en": "Komaram Bheem Asifabad",
    "district_te": "కుమారాం భీం ఆసిఫాబాద్",
    "constituencies": [
      { value: "Sirpur", label: "సిర్పూర్" },{ value: "Asifabad", label: "ఆసిఫాబాదు" }
    ],
    "mandals": [
      { value: "Koutal", label: "కౌతల" },{ value: "Bejjur", label: "బెజ్జూర్‌" },{ value: "Kagaznagar", label: "కాగజ్‌నగర్‌" },{ value: "Sirpur", label: "సిర్పూర్" },
{ value: "Dahegav", label: "దహేగావ్‌" },{ value: "Penchikalpet", label: "పెంచికల్ పేట్" },
{ value: "ChintalaManepalli", label: "చింతల మానేపల్లి" },{ value: "Kerameri", label: "కెరమెరి" },
{ value: "Vankidi", label: "వాంకిడి" },{ value: "SirpurTown", label: "సిర్పూర్ పట్టణ" },{ value: "Asifabad", label: "ఆసిఫాబాద్" },{ value: "Jainoor", label: "జైనూర్" },
{ value: "Tiryani", label: "తిర్యాని" },{ value: "Rebbena", label: "రెబ్బెన" },{ value: "Narnur", label: "నార్నూర్‌" },{ value: "Lingapur", label: "లింగాపూర్" }
    ]
  },

  {
    "district_en": "Mahabubabad",
    "district_te": "మహబూబాబాద్",
    "constituencies": [
      { value: "Palakurthi", label: "పాలకుర్తి" },{ value: "Dornakal", label: "డోర్నకల్" },
{ value: "Mahbubabad", label: "మహబూబాబాదు" },{ value: "Mulugu", label: "ములుగు" },{ value: "Illandu", label: "ఇల్లందు" }
    ],
    "mandals": [
      { value: "Palakurthi", label: "పాలకుర్తి" },{ value: "Devaruppula", label: "దేవరుప్పుల" },
{ value: "Kodakandla", label: "కొడకండ్ల" },{ value: "Rayaparthi", label: "రాయిపర్తి" },{ value: "Torrur", label: "తొర్రూర్" },
{ value: "PeddaVangara", label: "పెద్ద వంగర" },{ value: "Narsimhulapet", label: "నర్సింహులపేట" },{ value: "Maripeda", label: "మరిపెడ" },
{ value: "Kuravi", label: "కురవి" },{ value: "Dornakal", label: "డోర్నకల్" },{ value: "Goodur", label: "గూడూర్" },
{ value: "Nellikudur", label: "నెల్లికుదురు" },{ value: "Kesamudram", label: "కేసముద్రం" },{ value: "Mahbubabad", label: "మహబూబాబాద్" },
{ value: "Venkatapur", label: "వెంకటాపూర్" },{ value: "Aturunagaram", label: "ఏటూరునాగారం" },{ value: "Mangapet", label: "మంగపేట" },
{ value: "Tadvai", label: "తాడ్వాయి" },{ value: "Govindaravupet", label: "గోవిందరావుపేట" },{ value: "Mulugu", label: "ములుగు" },
{ value: "Nallabelli", label: "నల్లబెల్లి" },{ value: "Illandu", label: "ఇల్లందు" },{ value: "Vayaram", label: "బయ్యారం" },
{ value: "Garl", label: "గార్ల" },{ value: "Singareni", label: "సింగరేణి" },{ value: "Tekulapalli", label: "టేకులపల్లి" }
    ]
  },
  {
    "district_en": "Mahbubnagar",
    "district_te": "మహబూబ్‌నగర్",
    "constituencies": [
      { value: "Parigi", label: "పరిగి" },{ value: "Kodangal", label: "కొడంగల్" },
{ value: "Mahbubnagar", label: "మహబూబ్ నగర్" },{ value: "Jadcherla", label: "జడ్చర్ల" },
{ value: "Devarakadra", label: "దేవరకద్ర" },{ value: "Wanaparthy", label: "వనపర్తి" }
    ],
    "mandals": [
      { value: "Parigi", label: "పరిగి" },{ value: "Kulkacherla", label: "కుల్కచర్ల" },{ value: "Pudur", label: "పుడూర్" },{ value: "Doma", label: "దోమ" },
{ value: "Chowdapur", label: "చౌడాపూర్" },{ value: "Gandweed", label: "గాండ్వీడ్" },{ value: "Mahmabad", label: "మహ్మదాబాద్" },{ value: "Kodangal", label: "కొడంగల్" },
{ value: "Mahbubnagar", label: "మహబూబ్ నగర్" },{ value: "Hanwada", label: "హన్వాడ" },{ value: "Jadcherla", label: "జడ్చర్ల" },
{ value: "Nawabpet", label: "నవాబ్ పేట" },{ value: "Balanagar", label: "బాలానగర్" },{ value: "Midjil", label: "మిడ్జిల్" },{ value: "Bhootpur", label: "భూత్‌పూర్‌" },
{ value: "Addakal", label: "అడ్డాకల్" },{ value: "Devarakadra", label: "దేవరకద్ర" },{ value: "Chinnachintakunta", label: "చిన్నచింతకుంట" },{ value: "Kottakota", label: "కొత్తకోట" },
{ value: "Wanaparthy", label: "వనపర్తి" },{ value: "Peddamandadi", label: "పెద్దమందడి" },
{ value: "Pebberu", label: "పెబ్బేరు" },{ value: "Ghanpur", label: "ఘన్‌పూర్" },{ value: "Gopalapet", label: "గోపాలపేట" }
    ]
  },
  {
    "district_en": "Mancherial",
    "district_te": "మంచిర్యాల్",
    "constituencies": [
      { value: "Sirpur", label: "సిర్పూర్" },{ value: "Chennur", label: "చెన్నూర్‌" },
{ value: "Bellampalli", label: "బెల్లంపల్లి" },{ value: "Mancherial", label: "మంచిర్యాల" },{ value: "Khanapur", label: "ఖానాపూర్" }
    ],
    "mandals": [
      { value: "Koutal", label: "కౌతల" },
{ value: "Bejjur", label: "బెజ్జూర్‌" },{ value: "Kagaznagar", label: "కాగజ్‌నగర్‌" },{ value: "Sirpur", label: "సిర్పూర్" },
{ value: "Dahegav", label: "దహేగావ్‌" },{ value: "Penchikalpet", label: "పెంచికల్ పేట్" },{ value: "ChintalaManepalli", label: "చింతల మానేపల్లి" },
{ value: "Jaipur", label: "జైపూర్" },{ value: "Chennur", label: "చెన్నూర్‌" },{ value: "Kotapalli", label: "కోటపల్లి" },
{ value: "Mandamarri", label: "మందమర్రి" },{ value: "Kasipet", label: "కాసిపేట" },{ value: "Tandur", label: "తాండూరు" },
{ value: "Bellampalli", label: "బెల్లంపల్లి" },{ value: "Bheemini", label: "భీమిని" },{ value: "Nennel", label: "నెన్నెల్" },
{ value: "Vemanpalli", label: "వేమన్‌పల్లి" },{ value: "Laksettipet", label: "లక్సెట్టిపేట" },{ value: "Mancherial", label: "మంచిర్యాల" },
{ value: "Dandepalli", label: "దండేపల్లి" },{ value: "Jannaram", label: "జన్నారం" },{ value: "Utnur", label: "ఉట్నూర్" },
{ value: "KademPeddoor", label: "కడెం (పెద్దూర్)" },{ value: "Khanapur", label: "ఖానాపూర్" },{ value: "Indravelli", label: "ఇంద్రవెల్లి" }
    ]
  },

  {
    "district_en": "Medak",
    "district_te": "మేడక్",
    "constituencies": [
      { value: "Medak", label: "మెదక్" },{ value: "Narayanakhed", label: "నారాయణఖేడ్" },{ value: "Andol", label: "ఆందోల్" },
{ value: "Narsapur", label: "నర్సాపూర్" },{ value: "Dubbak", label: "దుబ్బాక" },{ value: "Gajwel", label: "గజ్వేల్" }
    ],
    "mandals": [
      { value: "Medak", label: "మెదక్" },{ value: "Papannapet", label: "పాపన్నపేట" },{ value: "Ramayampet", label: "రామాయంపేట" },
{ value: "Dubbak", label: "దుబ్బాక" },{ value: "Manur", label: "మనూర్" },{ value: "Narayanakhed", label: "నారాయణఖేడ్" },
{ value: "Kalher", label: "కల్హేర్" },{ value: "Shankarapet", label: "శంకరంపేట్" },{ value: "Sirgapur", label: "సిర్గాపూర్" },{ value: "Nagaligidd", label: "నాగలిగిద్ద" },
{ value: "Kangti", label: "కంగ్టి" },{ value: "Tekmal", label: "టెక్‌మల్" },{ value: "Alladurg", label: "అల్లాదుర్గ్" },{ value: "Regod", label: "రేగోడ్" },
{ value: "Rayikod", label: "రాయికోడ్" },{ value: "Andol", label: "ఆందోల్" },{ value: "Munpalli", label: "మున్‌పల్లి" },{ value: "Kaudipalli", label: "కౌడిపల్లి" },
{ value: "Kulcharam", label: "కుల్చారాం" },{ value: "Narsapur", label: "నర్సాపూర్" },{ value: "Hatnur", label: "హత్నూర్" },{ value: "Eldurthi", label: "ఎల్దుర్తి" },
{ value: "Pulkar", label: "పుల్కర్" },{ value: "Dubbak", label: "దుబ్బాక" },{ value: "Meerdoddi", label: "మీర్‌దొడ్డి" },
{ value: "Daulatabad", label: "దౌలతాబాద్" },{ value: "Chegunta", label: "చేగుంట" },{ value: "Togut", label: "తొగుట" },
{ value: "Gajwel", label: "గజ్వేల్" },{ value: "Kondapak", label: "కొండపాక" },{ value: "Gajwel", label: "గజ్వేల్" },
{ value: "Jagadevpur", label: "జగదేవ్‌పూర్" },{ value: "Vargal", label: "వర్గల్" },{ value: "Mulugu", label: "ములుగు" }
    ]
  },
  {
    "district_en": "Medchal-Malkajgiri",
    "district_te": "మేడ్చల్ మల్కాజిగిరి",
    "constituencies": [
      { value: "Medchal", label: "మేడ్చల్" },{ value: "Malkajgiri", label: "మల్కాజ్‌గిరి" },{ value: "Qutbullapur", label: "కుత్బుల్లాపూర్" },{ value: "Kukatpally", label: "కూకట్‌పల్లి" },
{ value: "Uppal", label: "ఉప్పల్" },{ value: "LalBahadurNagar", label: "లాల్ బహదూర్ నగర్" },{ value: "Serilingampally", label: "శేరిలింగంపల్లి" }
    ],
    "mandals": [
      { value: "Medchal", label: "మేడ్చల్" },{ value: "Shameerpet", label: "శామీర్‌పేట్‌" },{ value: "Ghatkesar", label: "ఘట్‌కేసర్" },{ value: "Keesara", label: "కీసర" },
{ value: "Mooduchintalapalli", label: "మూడుచింతలపల్లి" },{ value: "Medipalli", label: "మేడిపల్లి" },{ value: "Kapra", label: "కాప్రా" },
{ value: "Malkajgiri", label: "మల్కాజ్‌గిరి" },{ value: "Qutbullapur", label: "కుత్బుల్లాపూర్" },{ value: "Balanagar", label: "బాలానగర్" },
{ value: "Hyderabad", label: "హైదరాబాదు" },{ value: "Kukatpally", label: "కూకట్‌పల్లి" },{ value: "Uppal", label: "ఉప్పల్" },
{ value: "Gaddiannaram", label: "గడ్డిఅన్నారం" },{ value: "LBnagar", label: "ఎల్బీనగర్" },{ value: "Serilingampally", label: "శేరిలింగంపల్లి" }
    ]
  },
  {
    "district_en": "Mulugu",
    "district_te": "ములుగు",
    "constituencies": [
      { value: "Mulugu", label: "ములుగు" }
    ],
    "mandals": [
      { value: "Venkatapur", label: "వెంకటాపూర్" },{ value: "Aturunagaram", label: "ఏటూరునాగారం" },{ value: "Mangapet", label: "మంగపేట" },{ value: "Tadvai", label: "తాడ్వాయి" },
      { value: "Govindaravupet", label: "గోవిందరావుపేట" },{ value: "Mulugu", label: "ములుగు" },{ value: "Nallabelli", label: "నల్లబెల్లి" }
    ]
  },
  {
    "district_en": "Nagarkurnool",
    "district_te": "నాగర్ కర్నూల్",
    "constituencies": [
      { value: "Jadcherla", label: "జడ్చర్ల" },{ value: "Nagarkurnool", label: "నాగర్‌కర్నూల్" },{ value: "Achampet", label: "అచ్చంపేట" },
{ value: "Kalwakurthy", label: "కల్వకుర్తి" },{ value: "Kollapur", label: "కొల్లాపూర్" }
    ],
    "mandals": [
      { value: "Jadcherla", label: "జడ్చర్ల" },
{ value: "Nawabpet", label: "నవాబ్ పేట" },{ value: "Balanagar", label: "బాలానగర్" },{ value: "Midjil", label: "మిడ్జిల్" },
{ value: "Nagarkurnool", label: "నాగర్‌కర్నూల్" },{ value: "Taduru", label: "తాడూరు" },{ value: "Telkapalli", label: "తెల్కపల్లి" },
{ value: "Bizinpalli", label: "బిజినపల్లి" },{ value: "Timmajipet", label: "తిమ్మాజిపేట" },{ value: "Achampet", label: "అచ్చంపేట" },
{ value: "Uppunuthala", label: "ఉప్పునూతల" },{ value: "Balmur", label: "బల్మూర్" },{ value: "Lingal", label: "లింగాల" },
{ value: "Amrabad", label: "అమ్రాబాద్" },{ value: "Vanguru", label: "వంగూరు" },{ value: "Charagonda", label: "చారగొండ" },
{ value: "Padar", label: "పదర" },{ value: "Amanagal", label: "ఆమనగల్" },{ value: "Kadtal", label: "కడ్తాల్" },
{ value: "Madgul", label: "మాడ్గుల్" },{ value: "Thalkondapalli", label: "తలకొండపల్లి" },{ value: "Kalwakurthy", label: "కల్వకుర్తి" },
{ value: "Veldanda", label: "వెల్దండ" },{ value: "Kollapur", label: "కొల్లాపూర్" },{ value: "Veepanagandla", label: "వీపనగండ్ల" },
{ value: "Panagal", label: "పానగల్" },{ value: "Peddakothapalli", label: "పెద్దకొత్తపల్లి" },{ value: "Koderu", label: "కోడేరు" }
    ]
  },

  {
    "district_en": "Nalgonda",
    "district_te": "నల్గొండ",
    "constituencies": [
      { value: "Nalgonda", label: "నల్గొండ" },{ value: "Devarakonda", label: "దేవరకొండ" },{ value: "Nagarjunasagar", label: "నాగార్జునసాగర్" },
      { value: "Miryalaguda", label: "మిర్యాలగూడ" },{ value: "Munugode", label: "మునుగోడు" },{ value: "Nakrekal", label: "నకిరేకల్" },
      { value: "Thungathurthi", label: "తుంగతుర్తి" }
    ],
    "mandals": [
      { value: "Nalgonda", label: "నల్గొండ" },{ value: "Thipparthi", label: "తిప్పర్తి" },{ value: "Kangal", label: "కంగల్" },
      { value: "Devarakonda", label: "దేవరకొండ" },{ value: "Chintapalli", label: "చింతపల్లి" },{ value: "Gundlapalli_Dindi", label: "గుండ్లపల్లి ( డిండి )" },
      { value: "Chandampet", label: "చందంపేట" },{ value: "PeddaAdisharlapalli", label: "పెద్ద అడిశర్లపల్లి" },{ value: "KondaMallepalli", label: "కొండ మల్లేపల్లి" },
      { value: "Gudipalli", label: "గుడిపల్లి" },{ value: "Neredugommu", label: "నేరేడుగొమ్ము" },{ value: "Gurrampode", label: "గుర్రమ్‌పోడ్‌" },
      { value: "Peddavoora", label: "పెద్దవూర" },{ value: "Anumula", label: "అనుముల" },{ value: "Tripuraram", label: "త్రిపురారం" },
      { value: "Nidamanuru", label: "నిడమానూరు" },{ value: "Miryalaguda", label: "మిర్యాలగూడ" },{ value: "Damaracharla", label: "దామరచర్ల" },
      { value: "Vemulapalli", label: "వేములపల్లి" },{ value: "Munugode", label: "మునుగోడు" },{ value: "NarayanaPur", label: "నారాయణపూర్" },
      { value: "Mariguda", label: "మర్రిగూడ" },{ value: "Chandooru", label: "చండూరు" },{ value: "Nampally", label: "నాంపల్లి" },
      { value: "Choutuppal", label: "చౌటుప్పల్" },{ value: "Nakrekal", label: "నకిరేకల్" },
      { value: "Chityala", label: "చిట్యాల" },{ value: "Kattangoor", label: "కట్టంగూర్" },{ value: "KethePalli", label: "కేతేపల్లి" },
      { value: "Ramanapet", label: "రామన్నపేట" },{ value: "Narketpalli", label: "నార్కట్ పల్లి" },{ value: "Thungathurthi", label: "తుంగతుర్తి" },
      { value: "Thirumalagiri", label: "తిరుమలగిరి" },{ value: "Nagaram", label: "నాగారం" },{ value: "Jajireddygudem", label: "జాజిరెడ్డిగూడెం" },
      { value: "Shaligouraram", label: "శాలిగౌరారం" },{ value: "Motkur", label: "మోతుకూరు" },{ value: "Addaguduru", label: "అడ్డగూడూర్" },
      { value: "Noothankal", label: "నూతనకల్లు" },{ value: "Maddirala", label: "మద్దిరాల" }
    ]
  },
  {
    "district_en": "Narayanpet",
    "district_te": "నారాయణపేట్",
    "constituencies": [
      { "value": "నారాయణపేట్", "label": "నారాయణపేట్" },{ "value": "మక్తల్", "label": "మక్తల్" },
    ],
    "mandals": [
      { value: "Koilkonda", label: "కోయిలకొండ" },{ value: "Narayanpet", label: "నారాయణపేట" },{ value: "Damaragidda", label: "దామరగిద్ద" },
      { value: "Dhanwada", label: "ధన్వాడ" },{ value: "Makthal", label: "మక్తల్" },{ value: "Maganoor", label: "మాగనూరు" },
      { value: "Utkoor", label: "ఉట్కూర్" },{ value: "Atmakur", label: "ఆత్మకూరు" },{ value: "Narva", label: "నర్వ" }
    ]
  },
  {
    "district_en": "Nirmal",
    "district_te": "నిర్మల్",
    "constituencies": [
      { value: "Nirmal", label: "నిర్మల్" },{ value: "Mudhole", label: "ముధోల్" },{ value: "Khanapur", label: "ఖానాపూర్" }
    ],
    "mandals": [
      { value: "Dilawarpur", label: "దిలావర్ పూర్" },{ value: "Nirmal", label: "నిర్మల్" },{ value: "Laxmanchanda", label: "లక్ష్మణ్‌చందా" },
      { value: "Mamda", label: "మామడ" },{ value: "Sarangapur", label: "సారంగాపూర్" },{ value: "NirmalTown", label: "నిర్మల్ టౌన్" },
      { value: "NirmalRural", label: "నిర్మల్ రూరల్" },{ value: "NarsapurG", label: "నర్సాపూర్ (జి)" },{ value: "Son", label: "సోన్" },
      { value: "Kuntala", label: "కుంటాల" },{ value: "Kubeer", label: "కుభీర్" },{ value: "Bhainsa", label: "భైంసా" },
      { value: "Tanur", label: "తానూర్" },{ value: "Mudhole", label: "ముధోల్" },{ value: "Lokeswaram", label: "లోకేశ్వరం" },
      { value: "Jannaram", label: "జన్నారం" },{ value: "Utnoor", label: "ఉట్నూర్" },{ value: "KademPeddur", label: "కడెం (పెద్దూర్)" },
      { value: "Khanapur", label: "ఖానాపూర్" },{ value: "Indravelli", label: "ఇంద్రవెల్లి" }
    ]
  },
  {
    "district_en": "Nizamabad",
    "district_te": "నిజామాబాద్",
    "constituencies": [
      { value: "Armoor", label: "ఆర్మూర్" },{ value: "Bodhan", label: "బోధన్" },{ value: "NizamabadTown", label: "నిజామాబాదు పట్టణ" },
      { value: "NizamabadRural", label: "నిజామాబాదు గ్రామీణ" },{ value: "Balkonda", label: "బాల్కొండ" }
    ],
    "mandals": [
      { value: "Armoor", label: "ఆర్మూర్" },{ value: "Bodhan", label: "బోధన్" },{ value: "NizamabadTown", label: "నిజామాబాదు పట్టణ" },
      { value: "NizamabadRural", label: "నిజామాబాదు గ్రామీణ" },{ value: "Balkonda", label: "బాల్కొండ" },{ value: "Morthad", label: "మోర్తాడు" },
      { value: "Kammarpalli", label: "కమ్మర్‌పల్లి" },{ value: "Bheemgal", label: "భీంగల్" },{ value: "Velpur", label: "వెల్పూర్" }
    ]
  },

  {
    "district_en": "Peddapalli",
    "district_te": "పేదపల్లి",
    "constituencies": [
      { value: "Dharmapuri", label: "ధర్మపురి" },{ value: "Ramagundam", label: "రామగుండం" },
      { value: "Manthani", label: "మంథని" },{ value: "Peddapalli", label: "పెద్దపల్లి" }
    ],
    "mandals": [
      { value: "Dharmapuri", label: "ధర్మపురి" },{ value: "Dharmaram", label: "ధర్మారం" },{ value: "Gollapalli", label: "గొల్లపల్లి" },
      { value: "Velgatoor", label: "వెలగటూర్" },{ value: "Pegadapalli", label: "పెగడపల్లి" },{ value: "Buggaram", label: "బుగ్గారం" },
      { value: "Ramagundam", label: "రామగుండం" },{ value: "Kamanpur", label: "కమానుపూర్" },{ value: "Manthani", label: "మంథని" },
      { value: "Kataram", label: "కాటారం" },{ value: "Mahadevpur", label: "మహాదేవపూర్" },{ value: "Mutharam", label: "ముత్తారం" },
      { value: "Mallerrrao", label: "మల్‌హర్‌రావు" },{ value: "Mahamutharam", label: "మహా ముత్తారం" },{ value: "Palimela", label: "పలిమెల" },
      { value: "Ramagiri", label: "రామగిరి" },{ value: "Peddapalli", label: "పెద్దపల్లి" },{ value: "Julapalli", label: "జూలపల్లి" },
      { value: "Eligaid", label: "ఎలిగేడ్" },{ value: "Sultanabad", label: "సుల్తానాబాద్" },{ value: "Odela", label: "ఓదెల" },{ value: "Srirampur", label: "శ్రీరాంపూర్" }
    ]
  },
  {
    "district_en": "Rajanna Sircilla",
    "district_te": "రాజన్న సిరిసిల్ల",
    "constituencies": [
      { value: "Balkonda", label: "బాల్కొండ" },{ value: "Choppadandi", label: "చొప్పదండి" },
      { value: "Sircilla", label: "సిరిసిల్ల" },{ value: "Manakondur", label: "మానకొండూరు" }
    ],
    "mandals": [
      { value: "Balkonda", label: "బాల్కొండ" },{ value: "Morthad", label: "మోర్తాడు" },{ value: "Kammarpalli", label: "కమ్మర్‌పల్లి" },
      { value: "Bheemgal", label: "భీంగల్" },{ value: "Velpur", label: "వెల్పూర్" },{ value: "Gangadhara", label: "గంగాధర" },
      { value: "Ramadugu", label: "రామడుగు" },{ value: "Choppadandi", label: "చొప్పదండి" },{ value: "Malyal", label: "మల్యాల" },
      { value: "Kodimial", label: "కొడిమియాల్" },{ value: "Boinpalli", label: "బోయినపల్లి" },{ value: "Ellareddipet", label: "ఎల్లారెడ్డిపేట్" },
      { value: "Gambhiraopet", label: "గంభీర్‌రావ్‌పేట్" },{ value: "Mustabad", label: "ముస్తాబాద్" },{ value: "Sircilla", label: "సిరిసిల్ల" },
      { value: "Manakondur", label: "మానకొండూరు" },{ value: "Illanthakunta", label: "ఇల్లంతకుంట" },{ value: "Bejjanki", label: "బెజ్జంకి" },
      { value: "Thimmapur", label: "తిమ్మాపూర్" },{ value: "Shankarapatnam", label: "శంకరపట్నం" },{ value: "Ganneruvaram", label: "గన్నేరువరం" }
    ]
  },
  {
    "district_en": "Rangareddy",
    "district_te": "రంగారెడ్డి",
    "constituencies": [
      { value: "Ibrahimpatnam", label: "ఇబ్రహీంపట్నం" },{ value: "LB_Nagar", label: "లాల్ బహదూర్ నగర్" },{ value: "Maheshwaram", label: "మహేశ్వరం" },
      { value: "Rajendranagar", label: "రాజేంద్రనగర్" },{ value: "Serilingampally", label: "శేరిలింగంపల్లి" },{ value: "Chevella", label: "చేవెళ్ళ" },
      { value: "Kalwakurthy", label: "కల్వకుర్తి" },{ value: "Shadnagar", label: "షాద్‌నగర్" }
    ],
    "mandals": [
      { value: "Ibrahimpatnam", label: "ఇబ్రహీంపట్నం" },{ value: "Hayathnagar", label: "హయాత్‌నగర్‌" },{ value: "Manchal", label: "మంచాల" },{ value: "Yacharam", label: "యాచారం" },
      { value: "Saroornagar", label: "సరూర్‌నగర్" },{ value: "GaddiAnnaram", label: "గడ్డిఅన్నారం" },{ value: "LBNagar", label: "ఎల్బీనగర్" },
      { value: "Maheshwaram", label: "మహేశ్వరం" },{ value: "Kandukur", label: "కందుకూర్‌" },{ value: "Rajendranagar", label: "రాజేంద్రనగర్" },
      { value: "Shamshabad", label: "శంషాబాద్" },{ value: "Serilingampally", label: "శేరిలింగంపల్లి" },{ value: "Balanagar", label: "బాలానగర్" },
      { value: "Kukatpally", label: "కూకట్‌పల్లి" },{ value: "Chevella", label: "చేవెళ్ళ" },{ value: "Shabad", label: "షాబాద్‌" },
      { value: "Moinabad", label: "మొయినాబాద్‌" },{ value: "Nawabpet", label: "నవాబ్‌పేట" },{ value: "Shankarpally", label: "శంకర్‌పల్లి" },
      { value: "Amangal", label: "ఆమనగల్" },{ value: "Kadtal", label: "కడ్తాల్ (కొత్త)" },{ value: "Madgul", label: "మాడ్గుల్" },
      { value: "Talakondapally", label: "తలకొండపల్లి" },{ value: "Kalwakurthy", label: "కల్వకుర్తి" },{ value: "Veldanda", label: "వెల్దండ" },
      { value: "Shadnagar", label: "షాద్‌నగర్" },{ value: "Kothur", label: "కొత్తూరు" },{ value: "Keshampet", label: "కేశంపేట" },
      { value: "Kondurg", label: "కొందుర్గ్‌" },{ value: "Chowdergudem", label: "చౌదర్‌గూడెం" },{ value: "Nandigama", label: "నందిగామ" }
    ]
  },
  {
    "district_en": "Sangareddy",
    "district_te": "సంగారెడ్డి",
    "constituencies": [
      { value: "Jukkal", label: "జుక్కల్" },{ value: "Narayankhed", label: "నారాయణఖేడ్" },{ value: "Andole", label: "ఆందోల్" },
      { value: "Narsapur", label: "నర్సాపూర్" },{ value: "Sangareddy", label: "సంగారెడ్డి" },{ value: "Patancheru", label: "పటాన్‌చెరు" }
    ],
    "mandals": [
      { value: "Jukkal", label: "జుక్కల్" },{ value: "Manoor", label: "మనూర్" },{ value: "Narayankhed", label: "నారాయణఖేడ్" },
      { value: "Kalher", label: "కల్హేర్" },{ value: "Shankarampet", label: "శంకరంపేట్" },{ value: "Sirgapur", label: "సిర్గాపూర్" },
      { value: "Nagaligadda", label: "నాగలిగిద్ద" },{ value: "Kangti", label: "కంగ్టి" },{ value: "Tekmal", label: "టెక్‌మల్" },
      { value: "Alladurg", label: "అల్లాదుర్గ్" },{ value: "Regode", label: "రేగోడ్" },{ value: "Raikode", label: "రాయికోడ్" },
      { value: "Andole", label: "ఆందోల్" },{ value: "Munpally", label: "మున్‌పల్లి" },{ value: "Kowdipally", label: "కౌడిపల్లి" },
      { value: "Kulcharam", label: "కుల్చారాం" },{ value: "Narsapur", label: "నర్సాపూర్" },{ value: "Hathnoor", label: "హత్నూర్" },
      { value: "Eldurthi", label: "ఎల్దుర్తి" },{ value: "Pulkal", label: "పుల్కల్" },{ value: "Zaheerabad", label: "జహీరాబాద్" },
      { value: "Kohir", label: "కోహీర్" },{ value: "Nyalkal", label: "న్యాల్కల్" },{ value: "Jharasangam", label: "ఝారసంగం" },
      { value: "Sadashivapet", label: "సదాశివపేట్" },{ value: "Kondapur", label: "కొండాపూర్" },{ value: "Sangareddy", label: "సంగారెడ్డి" },
      { value: "Kandi", label: "కంది" },{ value: "Jinnaram", label: "జిన్నారం" },{ value: "Patancheru", label: "పటాన్‌చెరు" },
      { value: "Ramachandrapuram", label: "రామచంద్రాపురం" },{ value: "Aminpur", label: "అమీన్‌పూర్" },{ value: "Gummadidala", label: "గుమ్మడిదల" }
    ]
  },

  {
    "district_en": "Siddipet",
    "district_te": "సిద్ధిపేట",
    "constituencies": [
      { value: "Husnabad", label: "హుస్నాబాద్" },{ value: "Siddipet", label: "సిద్దిపేట" },
      { value: "Dubbak", label: "దుబ్బాక" },{ value: "Gajwel", label: "గజ్వేల్" }
    ],
    "mandals": [
      { value: "Chigurumamidi", label: "చిగురుమామిడి" },{ value: "Koheda", label: "కోహెడ" },{ value: "Husnabad", label: "హుస్నాబాద్" },
      { value: "Saidapur", label: "సైదాపూర్" },{ value: "Bheemadevarpally", label: "భీమదేవరపల్లి" },{ value: "Elkathurthi", label: "ఎల్కతుర్తి" },
      { value: "Siddipet Rural", label: "సిద్దిపేట రూరల్" },{ value: "Chinnakodur", label: "చిన్నకోడూర్" },{ value: "Nangunuru", label: "నంగునూర్" },
      { value: "Narayana Rao Pet", label: "నారాయణరావుపేట్" },{ value: "Siddipet Urban", label: "సిద్దిపేట అర్బన్" },{ value: "Dubbak", label: "దుబ్బాక" },
      { value: "Mirudoddi", label: "మీర్‌దొడ్డి" },{ value: "Daulatabad", label: "దౌలతాబాద్" },{ value: "Chegunta", label: "చేగుంట" },
      { value: "Toguta", label: "తొగుట" },{ value: "Gajwel", label: "గజ్వేల్" },{ value: "Kondapak", label: "కొండపాక" },
      { value: "Jagdevpur", label: "జగదేవ్‌పూర్" },{ value: "Wargal", label: "వర్గల్" },{ value: "Mulugu", label: "ములుగు" }
    ]
  },
  {
    "district_en": "Suryapet",
    "district_te": "సూర్యాపేట",
    "constituencies": [
      { value: "Huzurnagar", label: "హుజూర్‌నగర్" },{ value: "Kodad", label: "కోదాడ" },
      { value: "Suryapet", label: "సూర్యాపేట" },{ value: "Thungathurthi", label: "తుంగతుర్తి" }
    ],
    "mandals": [
      { value: "Huzurnagar", label: "హుజూర్‌నగర్" },{ value: "Nereducherla", label: "నేరేడుచర్ల" },{ value: "Garidepally", label: "గరిడేపల్లి" },{ value: "Mattampally", label: "మట్టంపల్లి" },
      { value: "Mellacheruvu", label: "మేళ్లచెరువు" },{ value: "Palakeedu", label: "పాలకవీడు" },{ value: "Kodad", label: "కోదాడ" },
      { value: "Mothey", label: "మోతే" },{ value: "Nadigudem", label: "నడిగూడెం" },{ value: "Munagala", label: "మునగాల" },
      { value: "Chilkur", label: "చిలుకూరు" },{ value: "Ananthagiri", label: "అనంతగిరి" },{ value: "Suryapet", label: "సూర్యాపేట" },
      { value: "Chivvemla", label: "చివ్వెంల" },{ value: "Penpahad", label: "పెన్‌పహాడ్" },{ value: "Atmakur_S", label: "ఆత్మకూరు (S)" },
      { value: "Thungathurthi", label: "తుంగతుర్తి" },{ value: "Thirumalagiri", label: "తిరుమలగిరి" },{ value: "Nagaram", label: "నాగారం" },
      { value: "Jajireddigudem", label: "జాజిరెడ్డిగూడెం" },{ value: "Shaligouraram", label: "శాలిగౌరారం" },{ value: "Motakoor", label: "మోతుకూరు" },
      { value: "Addagudur", label: "అడ్డగూడూర్" },{ value: "Nuthankal", label: "నూతనకల్లు" },{ value: "Maddirala", label: "మద్దిరాల" }
    ]
  },
  {
    "district_en": "Vikarabad",
    "district_te": "వికారాబాద్",
    "constituencies": [
      { value: "Chevella", label: "చేవెళ్ళ" },{ value: "Pargi", label: "పరిగి" },
      { value: "Vikarabad", label: "వికారాబాదు" },{ value: "Tandur", label: "తాండూరు" },{ value: "Kodangal", label: "కొడంగల్" }
    ],
    "mandals": [
      { value: "Chevella", label: "చేవెళ్ళ" },{ value: "Shahabad", label: "షాబాద్" },
      { value: "Moinabad", label: "మొయినాబాద్" },{ value: "Nawabpet", label: "నవాబ్‌పేట" },{ value: "Shankarpalli", label: "శంకర్‌పల్లి" },
      { value: "Pargi", label: "పరిగి" },{ value: "Kulkacherla", label: "కుల్కచర్ల" },{ value: "Pudur", label: "పుడూర్" },
      { value: "Doma", label: "దోమ" },{ value: "Chowdarapally", label: "చౌడాపూర్" },{ value: "Gandwada", label: "గాండ్వీడ్" },
      { value: "Mahmoodabad", label: "మహ్మదాబాద్" },{ value: "Vikarabad", label: "వికారాబాద్" },{ value: "Marpalli", label: "మర్‌పల్లి" },
      { value: "Mominpet", label: "మోమిన్‌పేట్" },{ value: "Dharur", label: "ధరూర్" },{ value: "Bantwaram", label: "బంట్వారం" },
      { value: "Kotepally", label: "కొట్‌పల్లి" },{ value: "Tandur", label: "తాండూరు" },{ value: "Kodangal", label: "కొడంగల్" }
    ]
  },
  {
    "district_en": "Wanaparthy",
    "district_te": "వనపర్తి",
    "constituencies": [
      { value: "Devarakadra", label: "దేవరకద్ర" },{ value: "Makthal", label: "మక్తల్" },
      { value: "Wanaparthy", label: "వనపర్తి" },{ value: "Kollapur", label: "కొల్లాపూర్" }
    ],
    "mandals": [
      { value: "Bhoothpur", label: "భూత్‌పూర్‌" },{ value: "Addakal", label: "అడ్డాకల్" },
      { value: "Devarakadra", label: "దేవరకద్ర" },{ value: "Chinnachintakunta", label: "చిన్నచింతకుంట" },{ value: "Kottakota", label: "కొత్తకోట" },
      { value: "Makthal", label: "మక్తల్" },{ value: "Maganoor", label: "మాగనూరు" },{ value: "Utkur", label: "ఉట్కూర్" },
      { value: "Atmakur", label: "ఆత్మకూరు" },{ value: "Narva", label: "నర్వ" },{ value: "Wanaparthy", label: "వనపర్తి" },
      { value: "Peddamandadi", label: "పెద్దమందడి" },{ value: "Pebbair", label: "పెబ్బేరు" },{ value: "Ghanpur", label: "ఘన్‌పూర్" },
      { value: "Gopalpet", label: "గోపాలపేట" },{ value: "Kollapur", label: "కొల్లాపూర్" },{ value: "Veepanagandla", label: "వీపనగండ్ల" },
      { value: "Panagal", label: "పానగల్" },{ value: "Peddakothapally", label: "పెద్దకొత్తపల్లి" },{ value: "Kodair", label: "కోడేరు" }
    ]
  },
  {
    "district_en": "Warangal",
    "district_te": "వరంగల్",
    "constituencies": [
      { value: "Palakurthi", label: "పాలకుర్తి" },{ value: "Narsampet", label: "నర్సంపేట" },{ value: "Parkal", label: "పరకాల" },
      { value: "Wardhannapet", label: "వర్ధన్నపేట" },{ value: "Bhupalpally", label: "భూపాలపల్లి" }
    ],
    "mandals": [
      { value: "Palakurthi", label: "పాలకుర్తి" },{ value: "Devaruppula", label: "దేవరుప్పుల" },{ value: "Kodakandla", label: "కొడకండ్ల" },
      { value: "Raiparthy", label: "రాయిపర్తి" },{ value: "Thorrur", label: "తొర్రూర్" },{ value: "Peddavangara", label: "పెద్ద వంగర" },
      { value: "Narsampet", label: "నర్సంపేట" },{ value: "Khanapur", label: "ఖానాపూర్" },{ value: "Chennaraopet", label: "చెన్నారావుపేట" },{ value: "Nekkonda", label: "నెక్కొండ" },
      { value: "Nallabelli", label: "నల్లబెల్లి" },{ value: "Duggondi", label: "దుగ్గొండి" },{ value: "Parkal", label: "పరకాల" },{ value: "Atmakur", label: "ఆత్మకూరు" },
      { value: "Sangem", label: "సంగెం" },{ value: "Geegonda", label: "గీసుగొండ" },{ value: "Nadikuda", label: "నడికుడా" },
      { value: "Damera", label: "దామెర" },{ value: "Hasanparthy", label: "హసన్‌పర్తి" },{ value: "Hanamkonda", label: "హన్మకొండ" },
      { value: "Ainavolu", label: "ఐనవోలు" },{ value: "Wardhannapet", label: "వర్ధన్నపేట" },{ value: "Parvathagiri", label: "పర్వతగిరి" },
      { value: "Mogullapalli", label: "మొగుళ్ళపల్లి" },{ value: "Chityal", label: "చిట్యాల" },{ value: "Bhupalpally", label: "భూపాలపల్లి" },
      { value: "Ghanpur", label: "ఘన్‌పూర్" },{ value: "Regonda", label: "రేగొండ" },{ value: "Shayampet", label: "శాయంపేట" }
    ]
  },
  {
    "district_en": "Yadadri Bhuvanagiri",
    "district_te": "యాదాద్రి భువనగిరి",
    "constituencies": [
      { value: "Munugode", label: "మునుగోడు" },{ value: "Bhuvanagiri", label: "భువనగిరి" },
      { value: "Nakrekal", label: "నకిరేకల్" },{ value: "Thungathurthi", label: "తుంగతుర్తి" },{ value: "Aleru", label: "ఆలేరు" }
    ],
    "mandals": [
      { value: "Munugode", label: "మునుగోడు" },{ value: "Narayapur", label: "నారాయణపూర్" },
      { value: "Marriguda", label: "మర్రిగూడ" },{ value: "Chandur", label: "చండూరు" },{ value: "Nampally", label: "నాంపల్లి" },
      { value: "Choutuppal", label: "చౌటుప్పల్" },{ value: "Gattuppal", label: "గట్టుప్పల్" },{ value: "Bhuvanagiri", label: "భువనగిరి" },
      { value: "Bibinagar", label: "బీబీనగర్" },{ value: "Valigonda", label: "వలిగొండ" },{ value: "Pochampally", label: "పోచంపల్లి" },
      { value: "Nakrekal", label: "నకిరేకల్" },{ value: "Chityal", label: "చిట్యాల" },{ value: "Kattangur", label: "కట్టంగూర్" },
      { value: "Ketepally", label: "కేతేపల్లి" },{ value: "Ramanapet", label: "రామన్నపేట" },{ value: "Narketpally", label: "నార్కట్ పల్లి" },
      { value: "Thungathurthi", label: "తుంగతుర్తి" },{ value: "Thirumalagiri", label: "తిరుమలగిరి" },{ value: "Nagaram", label: "నాగారం" },{ value: "Jajireddygudem", label: "జాజిరెడ్డిగూడెం" },
      { value: "Shaligouraram", label: "శాలిగౌరారం" },{ value: "Motakuru", label: "మోతుకూరు" },{ value: "Addaguduru", label: "అడ్డగూడూర్" },
      { value: "Nuthankal", label: "నూతనకల్లు" },{ value: "Maddirala", label: "మద్దిరాల" },{ value: "Aleru", label: "ఆలేరు" },
      { value: "Yadagirigutta", label: "యాదగిరి గుట్ట" },{ value: "Tirumalapur", label: "తుర్కపల్లి" },{ value: "Rajapet", label: "రాజాపేట" },
      { value: "Gundala", label: "గుండాల" },{ value: "Bommalaramaram", label: "బొమ్మలరామారం" },{ value: "AtmakurM", label: "ఆత్మకూరు(M)" }
  ]
}
]
  }
];

export const newsCategories = [
    { label: 'జాతీయం', value: 'national' },
    { label: 'ప్రపంచం', value: 'world' },
    { label: 'క్రైమ్', value: 'crime' },
    { label: 'వ్యాపారం/ఫైనాన్స్', value: 'business' },
    { label: 'టెక్నాలజీ', value: 'technology' },
    { label: 'వినోదం', value: 'entertainment' },
    { label: 'జీవనశైలి & సోషల్ మీడియా', value: 'lifestyle' },
    { label: 'క్రీడలు', value: 'sports' },
    { label: 'ఆరోగ్యం', value: 'health' },
    { label: 'ప్రభుత్వ ఉద్యోగాలు', value: 'employment' },
    { label: 'జ్యోతిష్యం', value: 'astrology' },
    { label: 'ఆధ్యాత్మికం', value: 'spiritual' },
    { label: 'రాజకీయాలు', value: 'politics' },
    { label: 'ఆహారం', value: 'food' },
    { label: 'వ్యవసాయం', value: 'agriculture' }
];

export const subCategories = [
  { value: "Business",      label: "వ్యాపారం" },
  { value: "Crime",         label: "క్రైమ్" },
  { value: "Technology",    label: "టెక్నాలజీ" },
  { value: "Agriculture",   label: "వ్యవసాయం" },
  { value: "Politics",      label: "రాజకీయాలు" },
  { value: "Entertainment", label: "వినోదం" },
  { value: "Sports",        label: "క్రీడలు" },
  { value: "Health",        label: "ఆరోగ్యం" }
];

// export const postTypes = ["India", "State News", "Special Day Wishes"];
export const postTypes = ['World','India', 'Andhra Pradesh', 'Telangana'];
export const SPECIAL_WISHES_POST_TYPE = 'Special Day Wishes';

export const jobRoles = [
  "Data entry & Back office", "Sales & Marketing", "BPO & Telecaller", "Driver",
  "Office Assistant", "Delivery & Collection", "Teacher", "Cook", 
  "Receptionist & Front office", "Operator & Technician", "IT Engineer & Developer", 
  "Hotel & Travel Executive", "Accountant", "Designer", "Other Jobs"
];

export const jobLocations = {
  "Andhra Pradesh": [ 
    "Anantapur", "Chittoor", "East Godavari", "Guntur", "Kadapa", "Krishna",
      "Kurnool", "Nellore", "Prakasam", "Srikakulam", "Visakhapatnam",
      "Vizianagaram", "West Godavari"
   ],
  "Telangana": [ 
    "Adilabad", "Bhadradri Kothagudem", "Hyderabad", "Jagtial", "Jangaon",
      "Jayashankar Bhupalpally", "Jogulamba Gadwal", "Kamareddy", "Karimnagar",
      "Khammam", "Komaram Bheem", "Mahabubabad", "Mahabubnagar", "Mancherial",
      "Medak", "Medchal–Malkajgiri", "Nagarkurnool", "Nalgonda", "Narayanpet",
      "Nirmal", "Nizamabad", "Peddapalli", "Rajanna Sircilla", "Rangareddy",
      "Sangareddy", "Siddipet", "Suryapet", "Vikarabad", "Wanaparthy",
      "Warangal (Rural)", "Warangal (Urban)", "Yadadri Bhuvanagiri"
   ],
  "Bangalore": [], // No districts
  "Chennai": [],   // No districts
};

export const sampleAds = [
  { id: 'ad1', imageUrl: '/ads/ads.png', link: '#', title: 'Example Product Ad', sponsor: 'Sponsor Inc.' },
  { id: 'ad2', imageUrl: '/ads/Amithab.png', link: '#', title: 'Promoting a Local Service', sponsor: 'Local Business' },
  { id: 'ad2', imageUrl: '/ads/kamal.png', link: '#', title: 'Example Product Ad', sponsor: 'Sponsor Inc.' },
  { id: 'ad3', imageUrl: '/ads/kattappa.png', link: '#', title: 'Promoting a Local Service', sponsor: 'Local Business' },
  { id: 'ad4', imageUrl: '/ads/prom.png', link: '#', title: 'Example Product Ad', sponsor: 'Sponsor Inc.' },
  // Add more ads here
];